/*
 * ------------------------------------------------------------------------
 * RIGHT MENU SLIDER FUNCTION STARTS
 * --------------------------------------------------------------------------
 */
window.sliderRightMenu = function() {

  /*IE-8 search placeholder fix*/
  initIe8Search();

  var max_width = "312px",
    min_width = "0px",
    animation_type = "linear",
    container_color = "#303030",
    right_arrow = $(".wcs-right_arrow");

  var buttons = $("button.slider, a.wcs-utility-nav-support-link"),
    right_panel = $(".wcs-right-panel"),
    panel_container = $(".wcs-panel-container"),
    glass = $(".wcs-panel-container #glass"),
    bag = $(".wcs-panel-container #bag"),
    star = $(".wcs-panel-container #star"),
    support = $(".wcs-panel-container #support"),
    sidenav_arrow = $("#sidenav-arrow"),
    main_container = $(".wcs-container.wcs-main"),
    content_glass = $(".wcs-right-panel .wcs-content-glass"),
    header_search = $(".wcs-hd-menu-search"),
    search_box_result = $(".wcs-new-search-box-result"),
    searchText = $('.search-bar-text'),
    content_bag = $(".wcs-right-panel .wcs-content-bag"),
    content_star = $(".wcs-right-panel .wcs-content-star"),
    content_support = $(".wcs-right-panel .wcs-content-support"),
    header = $("header"),
    footer = $("footer"),
    shipping_bar = $('.wcs-shipping-bar'),
    text = "",
    headerHeight = header.height() + shipping_bar.height(),
    footerHeight = $(footer).height(),
    fadeOutValue = 100,
    shoping_cart = $('#wcs-cart-container'),
    shoping_cart_num = $('.wcs-shopping-cart h5 span'),
    shoping_hometry_num = $('.wcs-home-try h5 span'),
    shortlist_tray_num = $('.wcs-shortlist-tray h5 span'),
    home_try_num = $('.wcs-home-try h5 span'),
    shortlist_tray = $('.wcs-shortlist-tray'),
    shortlist_tray_button = $('.wcs-shortlist-tray .wcs-tryon-athome, .wcs-shortlist-tray .wcs-addtobag'),
    tryathome = $('.wcs-content-bag .wcs-home-try'),
    fadeout_panel = $('.wcs-fadeout-right-nav'),
    fadeout_full_panel = $('.wcs-fadeout-full').not(".wcs-fadeout-full-overlay"),
    pageHt = $(document).height(),
    empty_text = $('.wcs-empty-text'),
    cost_container = $('.wcs-cost-container'),
    total_bag_circle = $('button[data-type="bag"] .wcs-product-count-circle'),
    total_star_circle = $('#star .wcs-product-count-circle'),
    deposit_container = $('.wcs-deposit-container'),
    slider_visible_product = 4,
    qvId = '';

  var win = $(window);
  var doc = $(document);
  var bdy = $('body');
  var _iPad = $(bdy).is('.ipad');
  var _android = $(bdy).is('.android');

  var headht = 0;
  var shipht = 0;

  var set_cost_container = function() {
    /*if(_iPad){
            $(cost_container).css('height', '27%');
          }*/
  };

  var _isNexus = navigator.userAgent.match(/nexus 10/i) !== null;
  var _isChrome = navigator.userAgent.match(/chrome/i) !== null;
  var _isAndroid422 = navigator.userAgent.match(/android 4.2.2/i) !== null;
  var _isNexusChrome = function() {
    return (_isAndroid422 && _isNexus && _isChrome);
  };

  var calc_headHeight = function(offset) {

    headht = header.height();

    if (shipping_bar.length) {
      headht = headht + shipht;
    }
    var topMessageDiv = $('div.wcs-top-message-container');
    if (topMessageDiv.is(':visible')) {
      headht += topMessageDiv.height();
    }
    headht -= getOffset(navigator.userAgent);
  };

  var calc_shipht = function() {
    shipht = shipping_bar.height();
  };

  calc_headHeight();
  calc_shipht();

  resize_panel = function() {
    //					$(right_panel).height($(window).height()-100 + 'px'); removed by mcleod
  };

  set_cost_container();
  calc_headHeight(true);
  calc_shipht();

  var windowHeight = null;
  var bodyHt = null;
  var scrollTop = null;

  var documentHeight = null;
  var difference = null;
  var buttonsclosed = true;

  resize_panel_header_footer = function() {

    windowHeight = win.height();
    documentHeight = doc.height();
    bodyHt = bdy.height();
    headerHeight = 100;
    scrollTop = win.scrollTop();

    documentHeight = documentHeight - scrollTop;
    difference = windowHeight - documentHeight;

    if (!_isNexusChrome()) {
      calc_headHeight(true);
      calc_shipht();
    }
    if ($('body').hasClass('ipad')) headerHeight = 100;
    if (WcsBrowser.isAndroid && (!WcsBrowser.isChrome)) {
      $(panel_container).css({
        'position': '',
        'top': ''
      });
      headerHeight = 102;
    }
    var messageDiv = $('div.wcs-top-message-container');
    if (messageDiv.is(':visible')) {
      headerHeight += messageDiv.height();
    }

    var supportDiv = $('div#wcs-sidebar-support-scroller');

    remixLC();

    // New Sticky Header + Right Panel
    var cookieMsg = $(".wcs-top-message-container");
    var cookieMsgHeight = cookieMsg.length ? cookieMsg.height() : 0;
    var shippingBar = $('.wcs-shipping-bar');
    var shippingBarHeight = shippingBar.outerHeight();
    var currentHeaderHeight = $(".rb-header").height();
    var totalHeight = (currentHeaderHeight + shippingBarHeight + cookieMsgHeight);
    var scrollValue = $(window).scrollTop();

    var sticky_init = cookieMsgHeight + shippingBarHeight;
    if (($("#pageName").val() == "ProductPage" && $("#ab-promo-stripe").length))
      sticky_init = currentHeaderHeight + shippingBarHeight;

    if (scrollValue === 0) {
      $(panel_container).css({
        'top': totalHeight
      });

      // Set right panel height relative to position
      $(right_panel).height(windowHeight - totalHeight);
      supportDiv.height(windowHeight - totalHeight);
    } else if (scrollValue > sticky_init) {
      if (_isNexusChrome()) {
        $(panel_container).css({
          'position': 'absolute',
          'top': +scrollTop + 'px'
        });
      } else {
        if ($("#pageName").val() == "ProductPage" && $("#ab-promo-stripe").length) {
          $(panel_container).css({
            'position': 'fixed',
            'top': '0'
          });
        }
        else {
          $(panel_container).css({
            'position': 'fixed',
            'top': currentHeaderHeight
          });
        }
      }

      // Set right panel height relative to position
      if ($("#pageName").val() == "ProductPage" && $("#ab-promo-stripe").length) {
        $(right_panel).height(windowHeight);
      }
      else {
        $(right_panel).height(windowHeight - currentHeaderHeight);
      }

      supportDiv.height(windowHeight - currentHeaderHeight);

    } else {
      if ($(".rb-header").hasClass('sticky')) {
        if (_isNexusChrome()) {
          $(panel_container).css({
            'position': 'absolute',
            'top': currentHeaderHeight - scrollTop
          });
        } else {
          $(panel_container).css({
            'position': 'fixed',
            'top': currentHeaderHeight
          });
        }

        // Set right panel height relative to position
        $(right_panel).height(windowHeight - currentHeaderHeight);
        supportDiv.height(windowHeight - currentHeaderHeight);

      } else {
        if (_isNexusChrome()) {
          $(panel_container).css({
            'position': 'absolute',
            'top': currentHeaderHeight - scrollTop
          });
        }
        $(panel_container).removeAttr('style');
        // Set right panel height relative to position
        $(right_panel).height(windowHeight - shippingBarHeight - currentHeaderHeight);
        supportDiv.height(windowHeight - shippingBarHeight - currentHeaderHeight);
      }
    }

    if (supportDiv.is(':visible') && !$('html').hasClass('ie8')) {
      if (window.supportScroller) {
        supportScroller.destroy();
      }
      window.supportScroller = new iScroll('wcs-sidebar-support-scroller', {
        hScrollbar: false,
        vScrollbar: true,
        draggableScrollbars: true,
        vScroll: true,
        hScroll: false
      });
    }
  };

  /*
   * Browse pages PLV/CLV/CLP
   */


  // function loadAjaxResponse()

  window.lazy_load = function() {
    if ($('#nextPagePLV').length === 0) {
      return;
    }
    var preInit = 400,
      scrollTop = $(window).scrollTop(),
      wHeight = $(window).height(),
      dHeight = $(document).height(),
      diff = (dHeight - wHeight) - preInit,
      nextPageURL = $('#nextPagePLV').val();

    if (scrollTop > diff) {
      var srcDivs = new Array(1);
      srcDivs[0] = $('#contentDiv').val();
      if ($('#nextPagePLV').length > 0) {
        var appliedFacets = "";
        if ($('#appliedFacets').length > 0) {
          appliedFacets = $('#appliedFacets').val();
        }
        if (scollInitiated === false) {
          scollInitiated = true;
          $('.wcs-footer').css('position', 'fixed');
          $('body').css('margin', '0 0 90px');
          loadPanels(nextPageURL, appliedFacets, srcDivs, null, 'POST', true);
        }
      }
    } else {
      $('.wcs-footer').css('position', 'relative');
      $('body').css('margin', 0);
    }
  };

  var is_max_width = function() {
    return $(right_panel).css("width") == max_width;
  };

  var is_glass_panel = function() {
    var on = $(panel_container).data("on");
    return on !== null && on === true;
  };

  var animate_slide = function(object, width, time, type, callback) {
    $(object).animate({
      width: width
    }, time, type, callback);
  };

  var show_fadeout = function() {
    docht = $(document).height();
    calc_headHeight(false);

    if ($('.wcs-shipping-bar').is(':visible')) {

      $(fadeout_panel).removeClass('wcs-hide').fadeIn(300);

      //fix rb-10781
      headht = $(".wcs-header").height();

      /**If cookie disabled message is visible add the div height*/
      if ($(".wcs-top-message-container").is(":visible")) headht += $(".wcs-top-message-container").outerHeight();

    } else {

      $(fadeout_panel).removeClass('wcs-hide').fadeIn(300);

    }
  };
  var hide_fadeout = function() {
    $(fadeout_panel).fadeOut(200, function() {
      $(fadeout_panel).addClass('wcs-hide');
    });
  };
  var show_full_fadeout = function() {
    var bdy = $('body');
    var docht = $(document).height();

    $(fadeout_full_panel).removeClass('wcs-hide');

    if ($(bdy).is('ipad') || $(bdy).is('android')) {
      $(fadeout_full_panel).css({
        'min-height': '100%',
        'z-index': '101'
      });
    } else {
      $(fadeout_full_panel).css({
        'height': docht + 'px',
        'z-index': '101'
      });
    }
  };
  window.show_full_fadeout_1 = show_full_fadeout;
  window.hide_full_fadeout = function(qvId) {
    if (qvId !== "D_QuickView" && qvId !== "D_QuickView_Prod") {
      $('#' + qvId).hide();
    }

    //RB:8167
    if ($(fadeout_full_panel).height() > 0 && $(".wcs-fadeout-full-overlay").is(":visible")) {
      if (qvId == "D_QuickView" || qvId == "D_QuickView_Prod") {
        $(fadeout_full_panel).removeClass('wcs-hide').removeAttr('style');
      } else {
        $(".wcs-fadeout-full-overlay").hide();
        if (qvId == "wcs_compare_quickview1") {
          $(".wcs-fadeout-full").hide();
        }
        if (qvId == "SignUpOverlay_main") {
          $(".wcs-fadeout-full").hide();
        }
      }

    } else {
      if ($(fadeout_full_panel).height() > 0) {
        $(fadeout_full_panel).removeClass('wcs-hide').removeAttr('style');
      } else if ($(".wcs-fadeout-full-overlay").is(":visible")) {
        $(".wcs-fadeout-full-overlay").hide();
      }

    }
  };

  /**
   * hide_search_by_image
   * hide Search By Image link in search input if it is enabled
   */
  var hide_search_by_image = function() {
    if ($('#EnableSearchByImage').val() === 'true') {
      $('.dnkws-label').hide();
      $('.si-label').hide();
    }
  }

  /**
   * show_search_by_image
   * show Search By Image link in search input if it is enabled
   */
  var show_search_by_image = function() {
    if ($('#EnableSearchByImage').val() === 'true') {
      $('.dnkws-label').show();
      $('.si-label').show();
    }
  }

  /**
   * onkeypress on search input, hide Search By Image link
   */
  $('.header-search-text-box').off('keydown').on('keydown', function() {
    hide_search_by_image();
    $(".button-search-left").removeAttr("disabled");
  });

  window.show_content_glass = function(version, showContentGlassCallback) {
    header_search.addClass('active');
    if ($('#ab-promo-stripe').length) {
      $('#ab-promo-stripe').addClass('wcs-hide');
    }
    // $('.wcs-glass-icon-search-form').addClass('close');
    show_search_by_image();

    if (!version || version !== 'input-only') {
      $('.wcs-glass-icon-search-form').parent().addClass('search-active');
      $('.wcs-right-panel').addClass('wcs-hide');
      if ($('.wcs-hd-menu-search.active').length > 0) {
        search_box_result.removeClass('wcs-hide').css('display', 'none');
        //$('.close-search-label').removeClass('wcs-hide');
        $('.dnkws-label').removeClass('wcs-hide');
        $('.si-label').removeClass('wcs-hide');
        $('.section-left').removeClass('wcs-hide');
        $('.section-right').removeClass('wcs-hide');
        search_box_result.slideToggle("normal");
        show_fadeout();
      }
    }

    if (showContentGlassCallback && (typeof showContentGlassCallback === 'function')) {
      showContentGlassCallback();
    }
  };


  /**
   * show_results_glass()
   * @param {boolean} cmd
   * show/hide search box results
   */
  window.show_results_glass = function(cmd) {
    var doShow = (cmd === false) ? false : true;

    if (doShow) {
      search_box_result.slideDown("normal");
      search_box_result.removeClass('wcs-hide');
      //$('.dnkws-label').removeClass('wcs-hide');
      //$('.si-label').removeClass('wcs-hide');
      $('.section-left').removeClass('wcs-hide');
      $('.section-right').removeClass('wcs-hide');
      show_fadeout();
    } else {
      //search_box_result.slideUp("normal");
      $('.section-left').addClass('wcs-hide');
      $('.section-right').addClass('wcs-hide');
      search_box_result.removeAttr("style");
      $('.dnkws-label').addClass('wcs-hide');
      $('.si-label').addClass('wcs-hide');
      $('.section-left').addClass('wcs-hide');
      $('.section-right').addClass('wcs-hide');
    }
  };

  /**
   * hide_content_glass
   * hide the whole search panel
   */
  window.hide_content_glass = function() {
    header_search.removeClass('active');
    if ($('#ab-promo-stripe').length) {
      $('#ab-promo-stripe').removeClass('wcs-hide');
    }
    // $('.wcs-glass-icon-search-form').removeClass('close');
    hide_search_by_image();

    $('.wcs-glass-icon-search-form').parent().removeClass('search-active');
    if ($('.wcs-hd-menu-search.active').length == 0) {
      // search_box_result.slideUp("normal", function () {
      search_box_result.removeAttr("style");
      $('.section-left').addClass('wcs-hide');
      $('.section-right').addClass('wcs-hide');
      $('.dnkws-label').addClass('wcs-hide');
      $('.si-label').addClass('wcs-hide');
      $('.section-left').addClass('wcs-hide');
      $('.section-right').addClass('wcs-hide');
      hide_fadeout();
      $(".wcs-hd-menu .wcs-primary.wcs_on > a")
        .filter('.wcs-selected').siblings(".wcs-drop_panel").css({
          "display": "block"
        });
      // });
    }
    $('.header-search-text-box').val('');
    $('.wcs-content-glass').hide();
  };

  window.show_content_bag = function() {
    $(content_bag).removeClass("wcs-hide").fadeIn('slow');
    $(buttons).removeClass('wcs-rightMenuActive');
    $("button.slider[data-type='bag']").addClass('wcs-rightMenuActive');

    if ($("#ExpPaypal").attr("value") == "true") {
      $(".wcs-paypal-container-minibasket .wcs-checkout-with-paypal").on("click", function() {
        $(".wcs-paypal-error").css("display", "none");
        $("#agreeConcent_popup").removeAttr("checked");
        $(".wcs-label-check.wcs-terms-and-conditions").removeClass("wcs-c-on");
        $(".wcs-fadeout-right-nav").addClass("wcs-hide");
        $(".wcs-right-panel").addClass("wcs-hide");
        wcs_paypal_overlay();
      });
      ($(".paypal-express-popup-content")).on("click", function() {
        $(".wcs-fadeout-right").removeClass("wcs-hide");
      });

      $(".wcs-close-btn").die("click").live("click", function() {
        setTimeout(function() {
          $(".wcs-fadeout-right-nav").removeClass("wcs-hide");
          $(".wcs-right-panel").removeClass("wcs-hide");
        }, 10);
      });

      $(".wcs-fadeout-full").die("click").live("click", function() {
        setTimeout(function() {
          $(".wcs-right-panel").removeClass("wcs-hide");
          $(".wcs-fadeout-right-nav").removeClass("wcs-hide");
        }, 10);
      });
    }

  };

  var hide_content_bag = function() {
    $(content_bag).hide().fadeOut(fadeOutValue);
    $(buttons).removeClass('wcs-rightMenuActive');
  };

  var show_content_star = function() {
    $(content_star).removeClass("wcs-hide").fadeIn('slow', function() {
      scroller();
    });
    $(buttons).removeClass('wcs-rightMenuActive');
    $("button.slider[data-type='star']").addClass('wcs-rightMenuActive');
  };

  var hide_content_star = function() {
    $(content_star).hide().fadeOut(fadeOutValue);
    $(buttons).removeClass('wcs-rightMenuActive');
  };

  var show_content_support = function() {

    $('.wcs-myacc-login').slideUp("normal");
    $('.wcs-login-link').removeClass('wcs-open');

    $(content_support).removeClass("wcs-hide").fadeIn('slow');
    $(buttons).removeClass('wcs-rightMenuActive');
    $(".wcs-utility-nav-support-link").addClass('wcs-rightMenuActive');
  };

  var hide_content_support = function() {
    $(content_support).hide().fadeOut(fadeOutValue);
    $(buttons).removeClass('wcs-rightMenuActive');
  };

  var show_content = function(type) {
    show_fadeout();
    switch (type) {
      case "glass":
        show_content_glass();
        break;
      case "bag":
        show_content_bag();
        break;
      case "star":
        show_content_star();
        break;
      case "support":
        show_content_support();
        break;
    }
  };

  var hide_content = function() {
    hide_content_star();
    hide_content_bag();
    //hide_content_glass();
    hide_content_support();
  };

  var display_content = function(object, top, xpos, ypos, type) {
    hide_content();
    if (is_max_width()) {
      if (!object.parent().is('.wcs-background-black')) {
        show_content(type);
      }
      setTimeout(function() {
        scroller();
      }, fadeOutValue);
    } else {
      $('.wcs-right-panel').removeClass('wcs-hide');
      animate_slide(right_panel, max_width, 150, animation_type, function() {
        show_content(type);
        scroller();
        resize_panel_header_footer();
        shoprunnerUpdateContent();
        $('.wcs-shopping-cart > div.wcs-minicart-prod').last().addClass('last');
        $('.wcs-shortlist-tray > div.wcs-minicart-prod').last().addClass('last');

      });
      if ($(object).attr("id") === "bag") {
        //Calling Analytics RB-16407 on MiniCart Slide opening
        tealium_data2track.push({
          id: 'WCS-D-X-Cart-Preview'
        });
      }
      $('.wcs-rightNav-notification').hide();
    }
    if (object.parent().hasClass("wcs-background-black")) {
      animate_slide(right_panel, min_width, 150, animation_type, function() {
        $('.wcs-right-panel').addClass('wcs-hide');
        reset_right_panel();
      });
    } else {
      $(right_arrow).css({
        "top": top + "%",
        "left": "100%"
      }).show();
      $(".wcs-right-nav button").parent().removeClass("wcs-background-black");
      object.parent().addClass("wcs-background-black");
    }
  };

  myScroll = [];
  window.scroller = function(runagain) {
    if (myScroll && myScroll.length > 0) {
      for (var i = 0; i < myScroll.length; i++) {
        if (myScroll[i] !== null) {
          myScroll[i].destroy();
        }
      }
      myScroll = [];
    }

    var wHeight = $(window).height();
    var bHeight = $('body').height();
    var scrollTop = $(document).scrollTop();
    var panelHeight = $('div.wcs-right-panel').height();
    $('.scrollable').each(function() {
      if ($(this).siblings('div.wcs-cost-container').length) {
        var costHeight = $(this).siblings('div.wcs-cost-container').outerHeight();
        $(this).css('height', panelHeight - costHeight + 'px');
      } else if ($(this).siblings('div.wcs-wishlist-compare-container').length) {
        var wishHeight = $(this).siblings('div.wcs-wishlist-compare-container').outerHeight();
        $(this).css('height', panelHeight - wishHeight + 'px');
      }
      id = $(this).attr('id');
      if ($('html').hasClass('ie8') && $(this).parent().hasClass('wcs-content-star')) {
        return;
      }
      myScroll.push(new iScroll(id, {
        hScrollbar: false,
        draggableScrollbars: true,
        onBeforeScrollStart: function() { }
      }));
    });

    if (runagain !== null && runagain) {
      scroller(false);
    }

    setTimeout(function() {
      if (myScroll && myScroll.length > 0) {
        for (var i = 0; i < myScroll.length; i++) {
          if (myScroll[i] !== null) {
            myScroll[i].refresh();
          }
        }
      }
    }, 800);

  };

  window.slide_back_right_panel = function() {
    animate_slide(right_panel, min_width, 150, animation_type, function() {
      $('.wcs-right-panel').addClass('wcs-hide');
      reset_right_panel();
    });
  };
  window.reset_right_panel = function() {
    hide_content();
    right_arrow.hide();
    resetnav_icon_background();
    hide_fadeout();
    reset_rightslider_quickbuy();
  };
  window.slide_back_rightPanel = function() {
    hide_fadeout();
    animate_slide(right_panel, min_width, 150, animation_type, function() {
      $('.wcs-right-panel').addClass('wcs-hide');
      hide_content();
      right_arrow.hide();
      resetnav_icon_background();
      reset_rightslider_quickbuy();
    });
  };
  window.resetnav_icon_background = function() {
    $('.wcs-button').removeClass('wcs-background-black');
  };
  window.product_opration = function(operation_type, parentAttrs) {

    switch (operation_type) {
      case "add_product":
        /* WCS INTEGERATED CODE */
        wcs_add_product(parentAttrs);
        break;

      case "save_product":
        window.add_product_tostar();
        break;
      case "unsave_product":
        window.add_product_notification(star);
        window.add_product_tostar();
        break;
    }
  };
  /* WCS INTEGERATED CODE */
  window.wcs_add_product = function(parentAttrs, addAccessory, isApplePay) {
    var serverName = $("input[name='serverDetails']").val() || "";
    var params = {};
    add_both_to_bag = 0;
    configurationId = "";
    if ($("#isRoxEnabled").length > 0 && $("#isRoxEnabled").val() == "true") {
      /**Add framecatEntryId, Lens catEntryId and services to the params*/
      var isQuickView = $("#D_QuickView_Prod").is(":visible");
      var catEntries = "";
      if (isQuickView) {
        params.catEntryId_1 = $("#frameCatentryId").val();
        params.catEntryId_2 = quickviewRox.selectedProductData.catentryId;
      } else {
        params.catEntryId_1 = $("#pdpFrameCatId").val();
        params.catEntryId_2 = typeof pdpRoxInst !== "undefined" ? pdpRoxInst.selectedProductData.catentryId : window.selectedProductData.catentryId;
      }
      params.quantity_1 = 1;
      params.quantity_2 = 1;
      catEntries = params.catEntryId_1 + "_" + params.catEntryId_2;
      var services = "";
      if (isQuickView) services = quickviewRox.selectedProductData.mandatoryServices;
      else services = typeof pdpRoxInst !== "undefined" ? pdpRoxInst.selectedProductData.mandatoryServices : window.selectedProductData.mandatoryServices;
      var servicesArr = services.split(",");
      if (servicesArr.length == 1) {
        params.catEntryId_3 = services;
        params.quantity_3 = 1;
        catEntries += "_" + params.catEntryId_3;
      } else {
        for (i = 0; i < servicesArr.length; i++) {
          var cnt = i + 3;
          params["catEntryId_" + cnt] = servicesArr[i];
          params["quantity_" + cnt] = 1;
          catEntries += "_" + params["catEntryId_" + cnt];
        }
      }

      params.roxSet_1 = catEntries;
      /**Add framecatEntryId, Lens catEntryId and services to the params ens here*/
      /**Add all the hidden param sets except catentry and quantity**/
      $(parentAttrs).each(function() {
        var getValue = $(this).val();
        var name = $(this).attr('name');
        if (name != "catEntryId" && name != "quantity") {
          params[name] = getValue;
        }
      });

    } else {
      var isRoxItem = false;
      var catIdVal = "";
      var catIdName = "";
      var quantityVal = "";
      var quantityName = "";
      var roxSet_1 = "";
      var roxSet_2 = "";

      $(parentAttrs).each(function() {
        var getValue = $(this).val();
        var name = $(this).attr('name');
        if (name == "catEntryId") {
          catIdVal = getValue;
          catIdName = name;
        } else if (name == "quantity") {
          quantityVal = getValue;
          quantityName = name;
        } else if (name == "roxSet") {
          if (getValue !== "" && getValue !== undefined) {
            catIds = getValue.split('_');
            var ind = 1;
            for (index = 0; index < catIds.length; index++) {
              if (catIds[index] !== '') {
                params["catentryId_" + ind] = catIds[index];
                params["quantity_" + ind] = 1;
                ind++;
              }
            }
            params.roxSet_1 = getValue;
            isRoxItem = true;
          }
        } else if (name == "roxSet_1") {
          if (getValue !== "" && getValue !== undefined) {
            roxSet_1 = getValue;
            isRoxItem = true;
            params[name] = getValue;
          }
        } else if (name == "roxSet_2") {
          if (getValue !== "" && getValue !== undefined) {
            roxSet_2 = getValue;
            isRoxItem = true;
            params[name] = getValue;
          }
        } else {
          params[name] = getValue;
        }

        if (addAccessory !== true && $(this).attr('id') == 'quantity_2') {
          add_both_to_bag = 2;
        } else if ($(this).attr('name') && $(this).attr('name').indexOf('configurationId') === 0) {
          configurationId = getValue;
        }

      });
      if (!isRoxItem) {
        params[catIdName] = catIdVal;
        params[quantityName] = quantityVal;
      }
      ind = 3;
      if (add_both_to_bag && isRoxItem) {
        if (roxSet_1 !== "") {
          var catenIds = roxSet_1.split('_');
          for (i = 0; i < catenIds.length; i++) {
            if (i !== 0) {
              params["catentryId_" + ind] = catenIds[i];
              params["quantity_" + ind] = "1";
              ind++;
            }
          }
        }
        if (roxSet_2 !== "") {
          var catenIds1 = roxSet_2.split('_');
          for (i = 0; i < catenIds1.length; i++) {
            if (i !== 0) {
              params["catentryId_" + ind] = catenIds1[i];
              params["quantity_" + ind] = "1";
              ind++;
            }
          }
        }
      }
    }

    if (window.Rayban && window.Rayban.rcInstance) {
      params = window.Rayban.rcInstance.getCurrentItemParams(params);
    }

    if (addAccessory === true) {
      if (add_both_to_bag == 2) {
        add_quantity += 2;
        add_both_to_bag = 0;
      } else {
        add_quantity += 1;
      }
    }
    if (configurationId !== "") {
      var encodedDynamicKitAddUrl = location.protocol + "//" + location.hostname + encodeURI(location.pathname) + "/AjaxDynamicKitOrderItemAdd";
      $.ajax({
        type: "POST",
        dataType: "json",
        url: encodedDynamicKitAddUrl,
        data: params,
      })
        .done(function(data) {
          if ($("#shopCartPage").val() == "ShopCart") {
            if (data.errorCode) {
              //Analytics RB-16407 in case of Failure
              tealium_data2track.push({
                id: 'Event',
                Events_Error: '1',
                Error_Source: 'Server',
                Error_Code: 'WCS <Recommended Section>- Add to cart -  ' + serverName + ' <short & technical description>' //customize the < > place holder
              });
            } else {
              //Analytics RB-16407 in case of Success
              tealium_data2track.push({
                id: 'WCS-X-X-Cart-UpdateDone'
              });
            }
            //Refreshing Page on adding from recommend section in cart
            location.reload();
          } else {
            window.add_product_tobag(data);
          }
        })
        .fail(function() {
          //Analytics RB-16407 in case of failure
          tealium_data2track.push({
            id: 'Event',
            Events_Error: '1',
            Error_Source: 'Server',
            Error_Code: 'WCS <PCP or PDP>- Add to cart - ' + serverName + '<short & technical description>' //customize the < > place holder
          });
          return false;
        });
    } else {
      /* Fix for NumberFormatException - Starts*/
      if ((params.catEntryId !== undefined && params.catEntryId !== null && params.catEntryId !== "" && !isNaN(params.catEntryId)) || (
        (params.catEntryId_1 !== undefined && params.catEntryId_1 !== null && params.catEntryId_1 !== "" && !isNaN(params.catEntryId_1)) &&
        (params.catEntryId_2 !== undefined && params.catEntryId_2 !== null && params.catEntryId_2 !== "" && !isNaN(params.catEntryId_2))) || (addAccessory === true) || (params.roxSet_1 !== undefined && params.roxSet_1 !== null && params.roxSet_1 !== "")) {
        /* Fix for NumberFormatException - Ends*/
        var encodedAddUrl = location.protocol + "//" + location.hostname + encodeURI(location.pathname) + "/AjaxOrderItemAdd";
        var asyncParam = true;
        if (isApplePay) {
          asyncParam = false;
          params.isApplePay = "true";
        }
        return $.ajax({
          type: "POST",
          dataType: "json",
          url: encodedAddUrl,
          async: asyncParam,
          data: params
        })
          .then(function(data) {
            clearSessionStorage();
            if ($("#shopCartPage").val() == "ShopCart") {
              if (data.errorCode) {
                //Analytics RB-16407 in case of Failure
                tealium_data2track.push({
                  id: 'Event',
                  Events_Error: '1',
                  Error_Source: 'Server',
                  Error_Code: 'WCS <Recommended Section>- Add to cart -  ' + serverName + ' <short & technical description>' //customize the < > place holder
                });
              } else {
                //Analytics RB-16407 in case of Success
                tealium_data2track.push({
                  id: 'WCS-X-X-Cart-UpdateDone'
                });
              }
              //Refreshing Page on adding from recommend section in cart
              location.reload();
            } else {
              return window.add_product_tobag(data, addAccessory, isApplePay);
            }
          })
          .done(function() {
            console.log('Minicart data updated');
            return true;
          })
          .fail(function() {
            //Analytics RB-16407 in case of failure
            tealium_data2track.push({
              id: 'Event',
              Events_Error: '1',
              Error_Source: 'Server',
              Error_Code: 'WCS <PCP or PDP>- Add to cart - ' + serverName + '<short & technical description>' //customize the < > place holder
            });
            return false;
          });

        /* Fix for NumberFormatException - Starts*/
      } else {
        if (window.console) {
          console.log("AddToBag will not be called as productId/CatentryId is not valid : " + params.productId);
        }
      }
      /* Fix for NumberFormatException - Ends*/
    }
  };

  //Added for wishlist logic
  window.wcs_add_product_star_to_bag = function(catEntryId, configurationId, roxSet) {
    var params = {};
    var isRoxItem = false;
    var catIdVal = "";
    var catIdName = "";
    var quantityVal = "";
    var quantityName = "";
    $("form[name='addProdItem'] input[type='hidden']").each(function() {
      var getValue = $(this).val();
      var name = $(this).attr('name');
      if (name == "catEntryId") {
        catIdVal = catEntryId.replace("add_", "");
        catIdName = name;
      } else if (name == "quantity") {
        quantityVal = getValue;
        quantityName = name;
      } else if (name == "configurationId") {
        params[name] = configurationId;
      } else if (name == "orderAgain") {
        params[name] = "";
      } else if (name.indexOf('roxSet') >= 0) {
        if (roxSet !== "" && roxSet !== undefined && !isRoxItem) {
          catIds = roxSet.split('_');
          var ind = 1;
          for (index = 0; index < catIds.length; index++) {
            params["catentryId_" + ind] = catIds[index];
            params["quantity_" + ind] = 1;
            ind++;
          }
          params.roxSet_1 = roxSet;
          isRoxItem = true;
        }
      } else {
        params[name] = getValue;
      }
    });
    if (!isRoxItem) {
      params[catIdName] = catIdVal;
      params[quantityName] = quantityVal;
    }

    if (window.Rayban && window.Rayban.rcInstance) {
      params = window.Rayban.rcInstance.getCurrentItemParams(params);
    }

    if (configurationId !== "") {
      var encodedDynamicKitAddUrl = location.protocol + "//" + location.hostname + encodeURI(location.pathname) + "/AjaxDynamicKitOrderItemAdd";
      $.ajax({
        type: "POST",
        dataType: "json",
        url: encodedDynamicKitAddUrl,
        data: params,
      })
        .done(function(data) {
          if ($("#pgName").length) {
            if (data.errorCode) {
              //Analytics RB-16407 in case of Failure
              tealium_data2track.push({
                id: 'Event',
                Events_Error: '1',
                Error_Source: 'Server',
                Error_Code: 'WCS <Wishlist>- Add to cart -  ' + serverName + ' <short & technical description>' //customize the < > place holder
              });
            } else {
              //Analytics RB-16407 in case of Success
              tealium_data2track.push({
                id: 'WCS-X-X-Cart-UpdateDone'
              });
            }
            //Refreshing Page on adding from Favourites section in cart
            location.reload();
          } else {
            window.add_product_tobag(data);
          }
        })
        .fail(function() {
          return false;
        });
    } else {
      /* Fix for NumberFormatException - Starts*/
      if ((params.catEntryId !== undefined && params.catEntryId !== null && params.catEntryId !== "" && !isNaN(params.catEntryId)) || (params.roxSet_1 !== undefined && params.roxSet_1 !== null && params.roxSet_1 !== "")) {
        /* Fix for NumberFormatException - Ends*/
        var encodedAddUrl = location.protocol + "//" + location.hostname + encodeURI(location.pathname) + "/AjaxOrderItemAdd";

        $.ajax({
          type: "POST",
          dataType: "json",
          url: encodedAddUrl,
          data: params,
        })
          .done(function(data) {
            if ($("#pgName").length) {
              if (data.errorCode) {
                //Analytics RB-16407 in case of Failure
                tealium_data2track.push({
                  id: 'Event',
                  Events_Error: '1',
                  Error_Source: 'Server',
                  Error_Code: 'WCS <Wishlist>- Add to cart -  ' + serverName + ' <short & technical description>' //customize the < > place holder
                });
              } else {
                //Analytics RB-16407 in case of Success
                tealium_data2track.push({
                  id: 'WCS-X-X-Cart-UpdateDone'
                });
              }
              //Refreshing Page on adding from Favourites section in cart
              location.reload();
            } else {
              window.add_product_tobag(data);
            }
          })
          .done(function() {
            console.log('Add product AJAX call completed');
            return true;
          })
          .fail(function() {
            return false;
          });
        /* Fix for NumberFormatException - Starts*/
      } else {
        if (window.console) {
          console.log("AddToBag will not be called as productId/CatentryId is not valid : " + params.productId);
        }
      }
      /* Fix for NumberFormatException - Ends*/
    }
  };

  window.refresh_my_favorites_section = function(object) {
    $("#wcs-my-favourites-my-selection").load("YourFavouritesView?storeId=" + $("#storeId").val() + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function() {
      window.shortlist_tray_length();
      custom_scrollable_hover();
      scroller();
      custom_label();
      //compare_thumb_hover();
      shopping_share_btn();
      sharePlus_emailToFriend_bind();
      $('.wcs-compare-products-button').removeClass('wcs-button-black');
      $('.wcs-compare-products-button').addClass('wcs-button-grey');
      var compareCount = 0;
      if ($('.compare-id-1').length == 1) {
        ++compareCount;
      }
      if ($('.compare-id-2').length == 1) {
        ++compareCount;
      }
      $('.wcs-mysel-compare-products-btn').html(compareCount);
      //$('div.wcs-fadeout-right-nav').height($('body').height() - 10);
    });
  };
  window.add_product_notification = function(object) {

    var product_notification = $(object).children('.wcs-notification');
    var total_product = $(object).children('.wcs-product-count-circle');
    var type = $(object).data('type');

    $(object).children('div').hide();
    /* new WCS changes */
    text_bag = $('#tcount').val();
    quantity = $('#quantity').val();

    if ($("#pName").length > 0 && $("#pName").val() == 'remixconfigurator') {
      quantity = 1;
    }
    text_star = $('#wcs-viewlistcount').val();

    total_product.addClass('wcs-hide');
    total_product.removeClass('wcs-hide');
    $(object).children('div').show();
    $('button[data-type=' + type + '] .wcs-product-count-circle').removeClass('wcs-hide');
    $(object).children('div').show();
    $('button[data-type=' + type + ']').addClass('wcs-added');
    shoprunnerUpdateContent();
    if ($(object).attr('data-type') == 'bag') {
      if (add_both_to_bag == 2) {
        $(object).parents('div.wcs-right-nav').find('.wcs-rightNav-notification .wcs-text').html('+' + 2);
        add_both_to_bag = 0;
      } else {
        if (add_quantity !== undefined) {
          $(object).parents('div.wcs-right-nav').find('.wcs-rightNav-notification .wcs-text').html('+' + add_quantity);
        } else {
          $(object).parents('div.wcs-right-nav').find('.wcs-rightNav-notification .wcs-text').html('+' + quantity);
        }
      }
      if (text_bag !== "") {
        var rightNav = $('div.wcs-right-nav');
        if (rightNav.is(':visible')) {
          $(object).parents('div.wcs-right-nav').find('.wcs-rightNav-notification').css({
            top: '53px',
            right: '75px'
          }).animate({
            opacity: 'toggle',
            right: '53'
          }, 500, function() {
            $(this).animate({
              opacity: 'toggle',
              right: '75px'
            }, 300);
          });
        } else {
          $('#wcs-top-cart-notification .wcs-text').html($('.wcs-rightNav-notification .wcs-text').html());
          $('#wcs-top-cart-notification').css({
            top: '87px'
          }).animate({
            opacity: 'toggle',
            top: '65px'
          }, 500, function() {
            $(this).animate({
              opacity: 'toggle',
              top: '87px'
            }, 300);
          });
        }
      }
      if (text_bag > 9) {
        $('button[data-type=' + type + '] .wcs-product-count-circle').css('padding-top', '2px').html('+');
      } else {
        $('button[data-type=' + type + '] .wcs-product-count-circle').css('padding-top', '3px').html(text_bag);
        /* Modification related to difect RB-8194 empty bag icon*/
        if (text_bag === "") {
          total_product.addClass('wcs-hide');
          $('button[data-type=' + type + '] .wcs-product-count-circle').addClass('wcs-hide');
        } else {
          total_product.removeClass('wcs-hide');
          $('button[data-type=' + type + '] .wcs-product-count-circle').removeClass('wcs-hide');
        }

      }
    } else if ($(object).attr('data-type') == 'star') {
      $(object).parents('div.wcs-right-nav').find('.wcs-rightNav-notification .wcs-text').html('+ 1');
      $(object).parents('div.wcs-right-nav').find('.wcs-rightNav-notification').removeAttr('style').css('right', '75px').animate({
        opacity: 'toggle',
        right: '53'
      }, 500, function() {
        $(this).animate({
          opacity: 'toggle',
          right: '75px'
        }, 300);
      });
      /* New header and side-nav changes*/
      if (text_star > 9) {
        $('button[data-type=' + type + '] .wcs-product-count-circle').css('padding', '1px 0px').html('+');
      } else {
        $('button[data-type=' + type + '] .wcs-product-count-circle').css('padding-top', '3px').html(text_star);
      }
    }
  };
  window.hide_deposit_container = function() {
    var scrollerHt = $('.scrollable').height(),
      scrollerInnerHt = $('.scrollable .scroller').height();
    if (scrollerHt < scrollerInnerHt) {
      $('.wcs-deposit-container').hide();
    }
  };
  window.show_deposit_container = function() {
    var scrollerHt = $('.scrollable').height(),
      scrollerInnerHt = $('.scrollable .scroller').height();
    if (scrollerHt > scrollerInnerHt) {
      $('.wcs-deposit-container').slideDown('slow');
    }
  };
  window.show_empty_container = function() {
    if ($(shoping_cart_num).html() < 1 && $(home_try_num).html() < 1) {
      $(empty_text).removeClass('wcs-hide');
      $(shoping_cart).removeClass('wcs-hide');
      $(tryathome).addClass('wcs-hide');
      $(cost_container).addClass('wcs-hide');
      $(total_bag_circle).addClass('wcs-hide');
    } else if ($(shoping_cart_num).html() < 1 && $(home_try_num).html() > 0) {
      $(shoping_cart).addClass('wcs-hide');
      $(empty_text).addClass('wcs-hide');
    } else if ($(shoping_cart_num).html() > 0 && $(home_try_num).html() < 1) {
      $(empty_text).addClass('wcs-hide');
      $(tryathome).addClass('wcs-hide');
      $(cost_container).removeClass('wcs-hide');
    } else if ($(shoping_cart_num).html() > 0 && $(home_try_num).html() > 0) {
      $(shoping_cart).removeClass('wcs-hide');
      $(tryathome).removeClass('wcs-hide');
    }
    /* Add this condition for WCS to work */
    else if ($(shoping_cart_num).html() > 0) {
      $(shoping_cart).removeClass('wcs-hide');
      $(empty_text).addClass('wcs-hide');
      $(cost_container).removeClass('wcs-hide');
    }
  };

  window.shoping_cart_length = function() {
    var total_cart = $('.wcs-shopping-cart > div').length;
    var total_hometry = $('.wcs-home-try > div').length;
    var total_bag_circle = $('button[data-type="bag"] .wcs-product-count-circle');
    var total_bag_count = $(total_bag_circle).html();
    $(shoping_cart_num).html($('#tcount').val());
    /* NEW WCS CHANGES */
    var total_count = $('#tcount').val();

    $('.wcs-shopping-cart > div.wcs-minicart-prod').last().addClass('last');

    if (total_count === "") {
      /* new WCS changes */
      $(total_bag_circle).addClass('wcs-hide');
      $('button[data-type="bag"]').removeClass('wcs-added');
    } else {
      if (total_count > 9) {
        $(total_bag_circle).removeClass('wcs-hide').html('+');
      } else {
        $(total_bag_circle).removeClass('wcs-hide').html(total_count);
      }
    }

    /* NEW WCS CHANGES ENDS */
  };
  window.shortlist_tray_length = function() {
    var total_star = $('#wcs-viewlistcount').val();
    var total_star_circle = $('button[data-type="star"] .wcs-product-count-circle');
    if (total_star === "" || total_star == "0") {
      $(total_star_circle).addClass('wcs-hide');
      $('button[data-type="star"]').removeClass('wcs-added');
    } else {
      if (total_star > 9) {
        $(total_star_circle).removeClass('wcs-hide').html('+');
      } else {
        $(total_star_circle).removeClass('wcs-hide').html(total_star);
      }
    }
  };
  window.home_try_length = function() {
    var total_hometry_pd = $('.wcs-home-try > div').length;
    $(home_try_num).html(total_hometry_pd);

  };
  window.add_product_tobag = function(data, isAcce, isApplePay) {
    if (data.outOfInventoryCatEntryIds !== undefined && data.outOfInventoryCatEntryIds !== "" && data.outOfInventoryCatEntryIds.length > 0) {
      var itemFound = false;
      if ($("#itemCatentryId")) {
        for (i = 0; i < data.outOfInventoryCatEntryIds.length; i++) {
          if (data.outOfInventoryCatEntryIds[i] == $("#itemCatentryId").val()) {
            itemFound = true;
          }
        }
      }
      if ($("#pgName") && $("#pgName").val() == "QuickView") {
        $(".so-quickviewContainer").show();
        $("#D_QuickView .wcs-addedtobag").hide();
        if (window.isROX === "true") $("#D_QuickView_Prod .wcs-addedtobag").hide();
        $("#wcs-quickView-AddToCartBtn").hide();
        $(".wcs-product-view-details-div").hide();
        $(".wcs-product-view-details-div").removeClass("wcs-borderTopGray");
      } else if ($("#pgName") && $("#pgName").val() == "PDP" && itemFound) {
        $(".so-pdpContainer").show();
        $("#wcs-QTY-display-Totalarea .wcs-right").hide();
        $("#wcs-hurryUp").hide();
        $(".hurryUp-icon").hide();
        $(".wcs-shipping-info-wrapper").hide();
      }
    } else {
      if (!isApplePay) {
        /* WCS INTEGERATED CODE */
        var serverName = $("input[name='serverDetails']").val() || "";
        if (data && data.errorCode) return;
        if (data.errorCode) {
          //Analytics RB-16407 in case of Failure
          tealium_data2track.push({
            id: 'Event',
            Events_Error: '1',
            Error_Source: 'Server',
            Error_Code: 'WCS <CLV QuickView>- Add to cart -  ' + serverName + ' <short & technical description>' //customize the < > place holder
          });
        } else {
          //Analytics RB-16407 in case of Success
          tealium_data2track.push({
            id: 'WCS-X-X-Cart-UpdateDone'
          });
        }
        if ($("#pgName") && ($("#pgName").val() == "QuickView")) {
          /*If quicview add clear session storage */
          sessionStorage.removeItem("rayban." + $("#storeId").val() + "." + $("#langId").val() + ".sidebar_refreshLS");
          sessionStorage.removeItem("rayban." + $("#storeId").val() + "." + $("#langId").val() + ".headerprofile_refreshLS");
          $(".quickview-prod-addtocart").show();
          if (window.isROX === "true") {
            $("#D_QuickView_Prod .wcs-addedtobag").hide();
            $("#D_QuickView_Prod .wcs-close-btn").click();
          } else {
            $("#D_QuickView .wcs-addedtobag").hide();
            $("#D_QuickView .wcs-close-btn").click();
          }
        }
        var accessories_enabled = $("#accessories_enabled") ? $("#accessories_enabled").val() : "false";
        var accessories = data.accessories;
        var cartCatEntryIds = $(".prodCatEntryId");
        var accFoundCount = 0;
        $.each(accessories, function(i, accessory) {
          var accCatEntryId = accessory.accCatentry;
          $.each(cartCatEntryIds, function(j, cartEntryId) {
            if (cartEntryId.value == accCatEntryId) {
              accFoundCount++;
            }
          });
        });

        if (accessories_enabled == "true" && accessories.length > 0 && isAcce !== true && accessories.length != accFoundCount) {
          //RB-8213
          if ($("#D_QuickView").is(":visible") || $("#D_QuickView_Prod").is(":visible") || $("#wcs_compare_quickview").is(":visible")) {
            $(".wcs-close-btn").trigger("click");
          }
          if ($(".wcs-right-panel").hasClass("wcs-hide") === false && $(".wcs-right-panel").width() !== 0) {
            $("#selenium-star").trigger("click");
            setTimeout(function() {
              window.showAccessoryPopup(data);
            }, 100);
          } else window.showAccessoryPopup(data);
        } else {
          /* MCR-checkout CR starts */
          /* if($('#wcs-redirect-cart-url').val() == 'Y') {
              window.location.href = $('#wcs-shopping-cart-url').val();
           } else {*/

          $("#selenium-bag").removeClass('avoidMiniCart');
          $("#selenium-bag").trigger("click");
          $("#selenium-bag").addClass('avoidMiniCart');

          //RB-8213
          if ($("#D_QuickView").is(":visible") || $("#D_QuickView_Prod").is(":visible") || $("#wcs_compare_quickview").is(":visible")) {
            $(".wcs-close-btn").trigger("click");
          }

          $(shoping_cart).children().remove();
          $(shoping_cart).load("MiniCartView?storeId=" + $("#storeId").val() + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function() {
            shoprunnerUpdateContent();
            $('.wcs-shopping-cart > div.wcs-minicart-prod').last().addClass('last');
            window.add_product_notification(bag);
            // hide_deposit_container();
            custom_scrollable_hover();
            scroller();
            openLinksInNewTab();
            Rayban.analytics.productsInMiniCart();
            if (Rayban.AfterPay) {
              Rayban.AfterPay.initOverlay();
            }
          });
          //}
          /*MCR-checkout CR ends */
        }
      }
    }
    console.log('add_product_tobag method end');

  };
  //$(".wcs-addtobag").off('click');

  if ($("#pdp_accs_modelCode_popup").length === 0) {
    $("#wcs_footer").before('<div id="pdp_accs_modelCode_popup" class="pdp_accs_add_popup wcs-quick-buy-lightbox" style="display:none;"></div>');
  }

  window.showAccessoryPopup = function(data) {
    if (data && data.errorCode && addAccessory !== true) return;

    var accessories = data.accessories;
    //If product already comes with accessory
    var productAccPartNumber = data.prodAccPartNumber;
    var cartCatEntryIds = $(".prodCatEntryId");
    $("#pdp_accs_modelCode_popup").html("");
    $(".wcs-Product-compare-lightbox").hide();
    var xdkInterestItem_Id = data.xdkInterestItem_Id ? data.xdkInterestItem_Id[0] : "";
    var calculateOrder = data.calculateOrder ? data.calculateOrder[0] : '';
    var pageName = data.pageName ? data.pageName[0] : "";
    var langId = data.langId ? data.langId[0] : "";

    var popupHTML = '<span class="wcs-close-btn"></span><div class="accs-add-popup-innerWrapper">';
    popupHTML += '<span class="wcs-accs-add-icon"></span><span class="wcs-product-count-circle acc-prod-added-icon">+</span><div class="accAdd-popup-header">' + $("#addedToBagText").val() + '<span class="accAdd-header-rightIcon"></span></div>';
    popupHTML += '<div class="accAdd-popup-body"><div class="accAdd-body-header">' + $("#addAccessoriesText").val() + '</div>';
    popupHTML += '<div class="header-values"><input type="hidden" name="URL" id="URL" value="' + data.URL + '"><input type="hidden" name="orderId" value=".">';
    popupHTML += '<input type="hidden" name="storeId" id="addProdItem_storeId" value="' + data.storeId[0] + '">';
    popupHTML += '<input title="langId" type="hidden" id="addProdItem_langId" name="langId" value="' + langId + '"><input type="hidden" name="calculateOrder" id="addAccProdItem_calculateOrder" value="' + calculateOrder + '"><input type="hidden" name="pageName" value="' + pageName + '"><input type="hidden" name="xdkInterestItem_Id" value="' + xdkInterestItem_Id + '"></div><div class="accessory-block-wrapper">';

    /*Accessory loop starts here*/
    $.each(accessories, function(i, accessory) {
      var cnt = i + 1;
      var standardPriceHTML = "";
      var promoPriceHTML = "";
      var shortDesc;
      var checkboxLabel = "";
      var accCatEntryId = accessory.accCatentry;
      var accFound = false;
      /****Skip accessory block if the ordered item already comes with this accessory****/
      if (productAccPartNumber == accCatEntryId) {
        return true;
      }
      /**********/
      /****Skip accessory block if its found in the cart****/
      $.each(cartCatEntryIds, function(j, cartCatEntryId) {
        if (cartCatEntryId.value == accCatEntryId) {
          accFound = true;
          return false;
        }
      });
      if (accFound === true) {
        return true;
      }
      /*****Accessory skip ends here******/
      var standardPrice = accessory.standardPrice.replace(/&amp;/g, '&');
      var promoPrice = accessory.promoPrice.replace(/&amp;/g, '&');
      var accmodeldesc = accessory.accCrosssellDesc.replace(/&gt;/g, '>');
      accmodeldesc = accmodeldesc.replace(/&lt;/g, '<');
      if (accessory.promoPrice !== "" && accessory.promoPrice != accessory.standardPrice) {
        standardPriceHTML = '<span class="acc-stdPrice-wrapper"><span class="acc-standard-price">' + standardPrice + '</span></span>';
        promoPriceHTML = '<span class="acc-promo-price">' + promoPrice + '</span>';
      } else {
        standardPriceHTML = '<span class="acc-standard-price">' + standardPrice + '</span>';
      }

      if (accessory.accShortDesc !== "" && accessory.accShortDesc !== undefined) {
        shortDesc = " - " + accessory.accShortDesc.toLowerCase();
      } else {
        shortDesc = "";
      }
      var localeval = $("#wcsCoutryAndLangId").val();
      if (localeval == "de_CH" || localeval == "de_AT" || localeval == "de_DE") {
        checkboxLabel = accessory.accShortDesc !== "" && accessory.accShortDesc !== undefined ? accessory.accShortDesc.toLowerCase() + " " + $("#addText").val() : $("#addText").val();
      } else {
        checkboxLabel = $("#addText").val() + ' ' + accessory.accModelName.toLowerCase() + shortDesc + ' ' + $("#bagText").val();
      }

      popupHTML += ' <div class="accessory-block"><div class="acc-block-left"><img src="' + accessory.accImageUrl + '"></div>';
      popupHTML += ' <div class="acc-block-right"><div class="acc-block-right-content"><div class="acc-model-name"><a href="' + accessory.accProductUrl + '">' + accessory.accModelName.toLowerCase() + shortDesc + '</a></div>';
      popupHTML += '<div class="acc-model-price">' + standardPriceHTML + promoPriceHTML + '</div>';
      popupHTML += ' <div class="acc-model-desc">' + accmodeldesc + '</div>';
      popupHTML += ' <div class="accAdd-check-wrapper"><label class="wcs-label-check"><input type="checkbox" name="accAdd-checkbox_' + cnt + '" id="accAdd-checkbox_' + cnt + '" class="accAdd-checkbox">';
      popupHTML += ' <span class="wcs-checkbox"></span><span class="wcs-padLeft-4">' + checkboxLabel + '</span></label></div></div></div>';

      popupHTML += '<input type="hidden" name="catEntryId_' + cnt + '" id="catEntryId_' + cnt + '" value="' + accessory.accCatentry + '"><input type="hidden" name="field1_' + cnt + '  " id="field1_' + cnt + '" value=""><input type="hidden" name="quantity_' + cnt + '" id="quantity_' + cnt + '" value="1">';
      popupHTML += '<input type="hidden" name="orderAgain_' + cnt + '" id="orderAgain_' + cnt + '" value=""><input type="hidden" name="configurationId_' + cnt + '" id="configurationId_' + cnt + '" value=""></div>';
    });
    /*Accessory block loop ends here*/

    popupHTML += '</div><div class="accAdd-action-block"><a href="javascript:void(0)">' + $("#noThanksText").val() + '</a><input type="button" id="accAdd-save" name="accAdd-save" class="accAdd-save" value="' + $("#continueText").val() + '"></div></div></div>';

    $("#pdp_accs_modelCode_popup").html(popupHTML);
    /******Set position of the popup*****/
    var scrollTop = $(document).scrollTop();
    var windowheight = $(window).height();
    var boxheight = $("#pdp_accs_modelCode_popup").height();
    if (boxheight + 40 > windowheight) {
      scrollTop = scrollTop - (boxheight + 40 - windowheight);
      if (scrollTop < 1) scrollTop = 0;
      $(document).scrollTop(scrollTop);
    }
    var left = ($(window).width() - $("#pdp_accs_modelCode_popup").width()) / 2;
    var top = ($(window).height() - $("#pdp_accs_modelCode_popup").height()) / 2 + scrollTop;
    if (windowheight > boxheight) {
      top = (windowheight - boxheight) / 2 + scrollTop;
    } else {
      top = scrollTop + 40;
    }
    $("#pdp_accs_modelCode_popup").css({
      'left': left,
      'top': top
    });
    var bdy = $('body');
    var docht = $(document).height();
    var fadeout_full_panel = $('.wcs-fadeout-full');
    $(fadeout_full_panel).removeClass('wcs-hide');

    if ($(bdy).is('ipad') || $(bdy).is('android')) {
      $(fadeout_full_panel).css({
        'min-height': '100%',
        'z-index': '101'
      });
    } else {
      $(fadeout_full_panel).css({
        'height': docht + 'px',
        'z-index': '101'
      });
    }
    /******Set position ends here******/

    $("#pdp_accs_modelCode_popup").removeClass("wcs-hidden").show();
    $(".accessory-block-wrapper").css("max-height", $(".accessory-block:first-child").height() + $(".accessory-block:nth-child(2)").height() + 85);

    $("#pdp_accs_modelCode_popup .wcs-close-btn,.accAdd-action-block a").click(function() {
      $("#pdp_accs_modelCode_popup").addClass("wcs-hidden").hide();
      $("#selenium-bag").removeClass('avoidMiniCart');
      $("#selenium-bag").trigger("click");
      $("#selenium-bag").addClass('avoidMiniCart');
      $(fadeout_full_panel).addClass('wcs-hide');
      add_product_tobag(data, true);
    });
    $(".accAdd-check-wrapper .wcs-label-check").on("click", function(e) {
      var targetElem = e.target;
      if ($(targetElem).hasClass("accAdd-checkbox")) {
        if ($(this).hasClass("wcs-c-on")) {
          $(this).removeClass("wcs-c-on");
        } else {
          $(this).addClass("wcs-c-on");
        }
      }
      e.stopPropagation();
    });
    $(".wcs-fadeout-full").click(function() {
      if ($(".pdp_accs_add_popup").css("display") == "none") {
        add_product_tobag(data, true);
      }
    });
    $("#accAdd-save").click(function(e) {
      $("#pdp_accs_modelCode_popup").addClass("wcs-hidden").hide();
      $(fadeout_full_panel).addClass('wcs-hide');
      var getParentAttr = $(".header-values").find('input[type="hidden"]');
      add_quantity = 0;
      $.each($(".accessory-block"), function(i, value) {
        if ($(this).find(".accAdd-checkbox").is(":checked")) {
          $.each($(this).find('input[type="hidden"]'), function(key, val) {
            getParentAttr.push(val);
          });
          add_quantity++;
        }
      });
      if ($(".accAdd-checkbox:checked").length > 0) {
        window.wcs_add_product(getParentAttr, true);
      } else {
        add_quantity = 1;
        $("#selenium-bag").removeClass('avoidMiniCart');
        $("#selenium-bag").trigger("click");
        $("#selenium-bag").addClass('avoidMiniCart');
        add_product_tobag(data, true);
      }
    });
  };

  window.refresh_DMP_LineId = function(lineId) {

    if (lineId !== undefined && $('#inputLineIDForDMP').length > 0) {
      $('#inputLineIDForDMP').val(lineId);
    }

  };

  window.add_product_tostar = function() {
    var wishListCnt = $('#wcs-viewlistcount').val();
    var params = {};
    var getLength = "";
    if (window.isROX === "true") getLength = $("#D_QuickView_Prod").not(":visible").length;
    else getLength = $("#D_QuickView").not(":visible").length;
    if (getLength === 0) {

      if (window.isROX === "true") {
        /**Add framecatEntryId, Lens catEntryId and services to the params*/
        params.catEntryId_1 = $("#frameCatentryId").val();
        var catEntries = params.catEntryId_1 + "_" + $("#catEntryId").val();
        var services = $("#mandatoryServices").val();
        var servicesArr = services.split(",");
        if (servicesArr.length == 1) {
          catEntries += "_" + $("#mandatoryServices").val();
        } else {
          for (i = 0; i < servicesArr.length; i++) {
            catEntries += "_" + servicesArr[i];
          }
        }

        params.configurationId_1 = catEntries;
        params.roxSet_1 = catEntries;
      } else {
        params.catEntryId = $('#D_QuickView #catEntryId').val();
      }
    } else {
      if ($("#isRoxEnabled").length > 0 && $("#isRoxEnabled").val() == "true") {
        /**Add framecatEntryId, Lens catEntryId and services to the params*/
        params.catEntryId_1 = $("#pdpFrameCatId").val();
        var selectedProductCatEntryId = typeof pdpRoxInst !== "undefined" ? pdpRoxInst.selectedProductData.catentryId : window.selectedProductData.catentryId;
        var rxcatEntries = params.catEntryId_1 + "_" + selectedProductCatEntryId;
        var rxservices = typeof pdpRoxInst !== "undefined" ? pdpRoxInst.selectedProductData.mandatoryServices : window.selectedProductData.mandatoryServices;
        var rxservicesArr = rxservices.split(",");
        if (rxservicesArr.length == 1) {
          var mandatoryServices = typeof pdpRoxInst !== "undefined" ? pdpRoxInst.selectedProductData.mandatoryServices : window.selectedProductData.mandatoryServices;
          rxcatEntries += "_" + mandatoryServices;
        } else {
          for (i = 0; i < rxservicesArr.length; i++) {
            rxcatEntries += "_" + rxservicesArr[i];
          }
        }

        params.configurationId_1 = rxcatEntries;
        params.roxSet_1 = rxcatEntries;
      } else {
        params.catEntryId = $('#catEntryId').val();
      }
    }
    params.langId = $('#langId').val();
    params.storeId = $('#storeId').val();
    params.catalogId = $('#catalogId').val();

    if (window.Rayban && window.Rayban.rcInstance && $('#pdp_page').hasClass('rc-lenses-selected')) {
      params = window.Rayban.rcInstance.getCurrentItemParams(params, true);
    }

    $.ajax({
      type: "POST",
      dataType: "json",
      url: "WishListAddCmd",
      data: params,
    })
      .done(function(response) {
        $("#wcs-star-container").children().remove();
        if (getLength === 0 && !response.errorCode) {
          var quickViewContainer = "";
          if (window.isROX === "true") quickViewContainer = $("#D_QuickView_Prod");
          else quickViewContainer = $("#D_QuickView");
          if (quickViewContainer.find(".wcs-fav-container").find("span").hasClass("wcs-quickbuy-favourite")) {
            quickViewContainer.find(".wcs-fav-container").find("span").removeClass("wcs-quickbuy-favourite").addClass("wcs-quickbuy-tickMark");
            quickViewContainer.find(".wcs-fav-container").find("a").addClass("wcs-favourite-added").text(quickViewContainer.find(" .wcs-fav-container").find("a").data("save-label"));
          }
        } else if (!response.errorCode) {
          $(".wcs-fav-container .wcs-icon-relative").addClass("wcs-pdp-tickMark");
          $("#D_PDP_Prod_AddToWishList").text($("#D_PDP_Prod_AddToWishList").data("save-label")).addClass("wcs-favourite-added");
        }
        sessionStorage.removeItem("rayban." + $("#storeId").val() + "." + $("#langId").val() + ".sidebar_refreshLS");
        sessionStorage.removeItem("rayban." + $("#storeId").val() + "." + $("#langId").val() + ".headerprofile_refreshLS");
        $("#wcs-star-container").load("WishListView?storeId=" + $("#storeId").val() + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function() {
          sidebarHideFavEmptyDiv();
          window.add_product_notification(star);
          window.shortlist_tray_length();
          // hide_deposit_container();
          custom_scrollable_hover();
          scroller();
          resize_panel_header_footer();
          sharePlus_emailToFriend_bind();
          openLinksInNewTab();

        });
      })
      .fail(function() {
        return false;
      });

  };

  window.add_to_favorites = function() {
    $("#wcs-star-container").children().remove();
    $("#wcs-star-container").load("MiniListView?storeId=" + $("#storeId").val() + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function() {
      sidebarHideFavEmptyDiv();
      window.add_product_notification(star);
      window.shortlist_tray_length();
      // hide_deposit_container();
      custom_scrollable_hover();
      scroller();
      resize_panel_header_footer();
      sharePlus_emailToFriend_bind();
    });

  };

  // Get basic parameters
  function getBasicParameters(buttonItem, endpointName) {
    let params = {}, mainParent = buttonItem.closest('.wcs-shopping-item-content');
    params.itemData = mainParent.data('info');
    params.wishListId = mainParent.data('listid');
    params.urlStr = window.wcs_endpoints[endpointName];
    params.langId = $('#langId').val();
    params.storeId = $('#storeId').val();
    params.catalogId = $('#catalogId').val();
    return params;
  }

  // Add saved item to cart
  function addSavedItemToCart(btn) {
    let basicParameters = getBasicParameters(btn, 'addToCart');
    let scriptEl = document.getElementById('data_pdp_addToBag');
    let addToBagDefaultData = JSON.parse(scriptEl.innerText);
    addToBagDefaultData = {
      eppSet: basicParameters.itemData.eppCatEntryId ? basicParameters.itemData.catentryId + '_' + basicParameters.itemData.eppCatEntryId : undefined,
      catalogId: basicParameters.catalogId,
      storeId: basicParameters.storeId,
      langId: basicParameters.langId,
      addManualPrescriptionFromWL: basicParameters.itemData.isManualPrescriptionAdded || false,
      eppCatEntryId: basicParameters.itemData.eppCatEntryId
    }

    // REMIX ITEMS
    if (basicParameters.itemData.isRemix) {
      addToBagDefaultData = {
        ...addToBagDefaultData,
        URL: 'WishListView',
        roxlensAndServiceSet: '',
        field1: '',
        orderId: '.',
        xdkInterestItem_Id: '',
        configurationId: basicParameters.itemData.configurationId,
        doInventory: 'N',
        calculateOrder: '1',
        calculationUsage: '-1, -3',
        catEntryId: basicParameters.itemData.catentryId,
        quantity: 1,
      }
      basicParameters.urlStr = '/AjaxDynamicKitOrderItemAdd'
    }

    // ROX ITEMS
    if (basicParameters.itemData.roxSet) {
      const roxSet = basicParameters.itemData.roxSet.split('_');
      addToBagDefaultData = {
        ...addToBagDefaultData,
        roxSet_1: basicParameters.itemData.roxSet
      }
      roxSet.forEach((item, index) => {
        addToBagDefaultData[`catEntryId_${index + 1}`] = item;
        addToBagDefaultData[`quantity_${index + 1}`] = 1;
        if (basicParameters.itemData.eppCatEntryId && index === roxSet.length - 1) {
          addToBagDefaultData[`catEntryId_${index + 2}`] = basicParameters.itemData.eppCatEntryId;
          addToBagDefaultData[`quantity_${index + 2}`] = 1;
        }
      });
    }

    // STANDARD ITEM
    if (!basicParameters.itemData.roxSet && !basicParameters.itemData.isRemix) {
      if (basicParameters.itemData.eppCatEntryId) {
        addToBagDefaultData.catEntryId_1 = basicParameters.itemData.catentryId;
        addToBagDefaultData.catEntryId_2 = basicParameters.itemData.eppCatEntryId;
        addToBagDefaultData.quantity_1 = 1;
        addToBagDefaultData.quantity_2 = 1;
        addToBagDefaultData.quantity = undefined;
      }

      if (!basicParameters.itemData.eppCatEntryId) {
        addToBagDefaultData.catEntryId = basicParameters.itemData.catentryId;
        addToBagDefaultData.quantity = 1;
      }
    }

    let productFromWishlist = basicParameters.itemData;
    let partNumber = productFromWishlist.partnumber;
    const type =
      productFromWishlist.isRemix === true
        ? 'CP'
        : productFromWishlist.isPrescription === true
          ? 'RX'
          : 'STD'
    let product = {
      Status: productFromWishlist.status,
      OosOptions: productFromWishlist.oosOptions,
      Conf_IsUpcSupported: '1',
      Category: productFromWishlist.category,
      Type: type,
      Engraving: '',
      Price: (productFromWishlist.price && productFromWishlist.price.offer) || '',
      PriceFull: (productFromWishlist.price && productFromWishlist.price.offer) || '',
      Size: productFromWishlist.modelSize,
      Sku: productFromWishlist.modelName,
      ModelName: productFromWishlist.name,
      MoCo: '',
      Image: productFromWishlist.image.replace('https:', ''),
      Url: productFromWishlist.pdpURL,
      LensColor: (productFromWishlist.lenses && productFromWishlist.lenses.value) || '',
      LensTechnology: '',
      FrameColor: (productFromWishlist.frame && productFromWishlist.frame.value) || '',
      FrameTechnology: productFromWishlist.frameMaterial,
      Shape: productFromWishlist.frameShape,
      Units: '1',
    }
    let Products = {};
    Products[partNumber] = product;
    $.ajax({
      url: basicParameters.urlStr,
      type: "POST",
      data: addToBagDefaultData,
      async: false,
      dataType: "json",
      success: function() {
        tealium_data2track.push({
          id: 'Event',
          Events_CartAdd: '1',
          Products,
        });
        removeFromSavedSection(btn);
      },
      error: function(xhr, status, error) {
        console.log(error, 'add saved item to cart error');
      }
    });

  }

  // Remove saved item
  function removeFromSavedSection(btn) {
    let basicParameters = getBasicParameters(btn, 'removeFromWishlist');
    let params = {};
    if (basicParameters.itemData.roxSet && basicParameters.itemData.configurationId) {
      //rox case
      params = {
        catalogId: basicParameters.catalogId,
        storeId: basicParameters.storeId,
        langId: basicParameters.langId,
        doInventory: 'N',
        catEntryId: basicParameters.itemData.catentryId,
        listId: basicParameters.wishListId,
        isOnlyRemoveFromStar: true,
        roxSet: basicParameters.itemData.roxSet,
        configurationId: basicParameters.itemData.configurationId,
      }
    } else if (!basicParameters.itemData.roxSet && basicParameters.itemData.configurationId) {
      //remix case
      params = {
        catalogId: basicParameters.catalogId,
        storeId: basicParameters.storeId,
        langId: basicParameters.langId,
        doInventory: 'N',
        catEntryId: basicParameters.itemData.catentryId,
        listId: basicParameters.wishListId,
        isOnlyRemoveFromStar: true,
        configurationId: basicParameters.itemData.configurationId,
      }
    } else {
      //normal case
      params = {
        catalogId: basicParameters.catalogId,
        storeId: basicParameters.storeId,
        langId: basicParameters.langId,
        doInventory: 'N',
        catEntryId: basicParameters.itemData.catentryId,
        listId: basicParameters.wishListId,
        isOnlyRemoveFromStar: true,
      }
    }

    $.ajax({
      url: basicParameters.urlStr,
      type: "POST",
      data: params,
      async: false,
      dataType: "json",
      success: function(data) {
        var updateCart = new CustomEvent('addToBag', {});
        document.dispatchEvent(updateCart);
        location.reload();
      },
      error: function(xhr, status, error) {
        console.log('remove wishlist error');
      }
    });
  }

  //function for checking badges and case
  function showItemFunction(currentProperty, allPropsObj, template) {
    let propertyObject = {
      isRemix: '.wcs-remixed-label-basket',
      isPrescription: '.DESK_ROX_Label',
      includedText: '.included-text-item',
      isJuniorItem: '.shopbag-junior-icon'
    }

    const zeroPowerProps = {
      isZeroPower: '.DESK_ROX_Label'
    }

    let currItem = propertyObject[currentProperty];
    const isZeroPowerItem = zeroPowerProps[currentProperty];
    if (currItem && allPropsObj[currentProperty]) {
      template.find(currItem).removeClass('wcs-hide');
    }

    if (isZeroPowerItem && allPropsObj[currentProperty]) {
      template.find(isZeroPowerItem).text('Non prescription').removeClass('wcs-hide').addClass('reset-padding');
    }

    if (currentProperty === 'category' && allPropsObj[currentProperty] === 'Electronics') {
      template.find('.wcs-product--electronics').removeClass('wcs-hide');
    }

    if (currentProperty === 'preOrderFlag' && allPropsObj[currentProperty] === 'TRUE') {
      template.find('.pre-order-badge').removeClass('wcs-hide');
    }
  }

  function setValuesToSavedForLaterItem(itemData, listId) {
    var savedItemTemplate = $('.saved-item-temlate-example').clone();
    savedItemTemplate.data('info', itemData);
    savedItemTemplate.data('listid', listId);
    $('.saved-for-later-section').append(savedItemTemplate);
    for (const prop in itemData) {
      var el = savedItemTemplate.find('[data-' + prop + ']');
      showItemFunction(prop, itemData, savedItemTemplate);
      if (prop === 'status' && itemData[prop].toLowerCase() !== 'available') {
        savedItemTemplate.find('.add-item-to-cart').hide();
        savedItemTemplate.find('.wcs-shopping-item-price').hide();
        if (itemData[prop] === 'Out-of-stock') {
          savedItemTemplate.find('.out-of-stock-badge').removeClass('wcs-hide');
        }
      }
      if (prop === 'catentryId') {
        savedItemTemplate.attr('data-catentryId', itemData[prop]);
      }
      if (el.length) {
        el.each(function(index, currEl) {
          var attrParam = $(currEl).data(prop.toLocaleLowerCase());
          var propVal = itemData[prop];
          if (attrParam === 'text') {
            if (typeof propVal === 'object') {
              if (prop === 'price') {
                var offerPrice = propVal['offer'];
                $(currEl).text(new Intl.NumberFormat(window.wcs_config.locale, { style: 'currency', currency: window.wcs_config.currency }).format(
                  Number(propVal['list'])
                ));
                if (offerPrice < propVal['list']) {
                  $(currEl).next().text(new Intl.NumberFormat(window.wcs_config.locale, { style: 'currency', currency: window.wcs_config.currency }).format(
                    Number(offerPrice)
                  ));
                  $(currEl).closest('.wcs-shopping-item-price').addClass('is-offer-price');
                }
              } else {
                $(currEl).text(propVal['value']);
              }
            } else {
              if (prop === 'price') {
                $(currEl).text(new Intl.NumberFormat(window.wcs_config.locale, { style: 'currency', currency: window.wcs_config.currency }).format(
                  Number(propVal)));
                //this conditions for remix PST price
                let remixPST = itemData['discountPrice'];
                const remixPSTToNumber = Number(remixPST);
                const propValToNumber = Number(propVal);
                if (remixPSTToNumber && remixPSTToNumber < propValToNumber) {
                  $(currEl).next().text(new Intl.NumberFormat(window.wcs_config.locale, { style: 'currency', currency: window.wcs_config.currency }).format(
                    Number(remixPST)
                  ));
                  $(currEl).closest('.wcs-shopping-item-price').addClass('is-offer-price');
                }
              } else {
                $(currEl).text(propVal);
              }
            }
          } else if (attrParam === 'src' && !itemData.isRemix) {
            $(currEl).attr(attrParam, (propVal + '&bgc=%23f2f2f2'));
          } else {
            $(currEl).attr(attrParam, propVal);
          }
        });
      }
    }
    savedItemTemplate.find('.add-item-to-cart').attr('data-description', itemData.name + '_' + itemData.partnumber);
    savedItemTemplate.find('.wcs-saved-item-remove').off().on('click', function() {
      var thisDataId = $(this).attr('data-element-id');
      tealium_data2track.push({
        id: 'Click',
        Tracking_Type: 'hiddenaction',
        Click_FocusElement: this,
        data_element_id: thisDataId,
      });
      removeFromSavedSection($(this));
    });
    savedItemTemplate.find('.add-item-to-cart').off().on('click', function() {
      addSavedItemToCart($(this));
    });
    if (!!itemData && itemData.category === 'gift-cards') {
      if (!!savedItemTemplate.find('.wcs-product-blurb')) {
        savedItemTemplate.find('.wcs-product-blurb').hide();
      }
      if (!!savedItemTemplate.find('.add-item-to-cart')) {
        $(savedItemTemplate.find('.add-item-to-cart')).addClass('add-item-to-cart--gift-card')
      }
    }
    savedItemTemplate.removeClass('wcs-hide');
    savedItemTemplate.removeClass('saved-item-temlate-example');
    document.cookie = "savedForLater=true; path=/; max-age=2592000;";
    $('.saved-for-later-section').show();
  };

  function showPreviousStepMesaage(data) {
    let messageItem = $('.removed-item-message');
    let revertLink = messageItem.find('.revert-removeditem-link');
    messageItem.find('.saved-item-name').text(data.textForMessage);
    messageItem.show();
    revertLink.off().on('click', function() {
      var thisDataId = $(this).attr('data-element-id');
      tealium_data2track.push({
        id: 'Click',
        Tracking_Type: 'hiddenaction',
        Click_FocusElement: this,
        data_element_id: thisDataId,
      });
      if (data.isGWP) {
        $.ajax({ url: "RBRestoreGWPGift?orderId=" + data.orderId, async: false }).done(function() {
          localStorage.setItem('previousRemoved', '');
          location.reload();
        });
        return;
      }
      let scriptEl = document.getElementById('data_pdp_addToBag');
      let addToBagDefaultData = JSON.parse(scriptEl.innerText);
      let urlAddress = window.wcs_endpoints['addToCart'];
      let params = {
        ...addToBagDefaultData,
        catalogId: $('#catalogId').val(),
        storeId: $('#storeId').val(),
        langId: $('#langId').val(),
        eppSet: data.isEyeProtectionSelected ? data.eppSet : undefined,
        eppCatEntryId: data.isEyeProtectionSelected ? data.eppCatEntryId : undefined
      }
      // REMIX CASE
      if (data.roxSet === '' && data.configurationId) {
        params.catEntryId = data.catEntryId
        params.configurationId = data.configurationId
        urlAddress = '/AjaxDynamicKitOrderItemAdd';
        //ROX CASE
      } else if (data.roxSet) {
        let roxSetArray = data.roxSet.split('_')
        for (let i = 0; i < roxSetArray.length; i++) {
          params['catEntryId_' + (i + 1)] = roxSetArray[i]
          params['quantity_' + (i + 1)] = 1
        }
        params[`catEntryId_${roxSetArray.length + 1}`] = params.eppCatEntryId || undefined
        params[`quantity_${roxSetArray.length + 1}`] = params.eppCatEntryId ? 1 : undefined;
        params.roxSet_1 = data.roxSet
        delete params.quantity
      } else {
        if (params.eppCatEntryId) {
          params.catEntryId_1 = data.catEntryId;
          params.catEntryId_2 = data.eppCatEntryId;
          params.quantity_1 = 1;
          params.quantity_2 = 1;
          params.quantity = undefined;
        }

        if (!params.eppCatEntryId) {
          params.catEntryId = data.catEntryId;
          params.quantity = 1;
        }
      }

      $.ajax({
        url: urlAddress,
        type: "POST",
        data: params,
        async: false,
        dataType: "json",
        success: function(addToCartResponse) {
          var previousData = JSON.parse(localStorage.getItem('previousRemoved'));
          var manualPrescription = JSON.parse(localStorage.getItem('prescriptionObject'));

          if (previousData?.hasPrescription && manualPrescription?.prescriptionFlow?.toLowerCase() === 'manual') {
            var pupillaryDistanceIsSingleValue = !manualPrescription.PD?.OS && !!manualPrescription.PD?.OD
            var normalizedObject = {
              prescriptionFlow: manualPrescription.prescriptionFlow,
              prescriptionId: manualPrescription.prescriptionId,
              orderId: addToCartResponse.orderId[0],
              orderItemId: addToCartResponse.newOrderItemId_0 || addToCartResponse.newOrderItemId_1,
              lsphreading: manualPrescription.SPH?.OS,
              lcycreading: manualPrescription.CYL?.OS,
              laxisreading: manualPrescription.AX?.OS,
              ladddetails: manualPrescription.ADD?.OS,
              rsphreading: manualPrescription.SPH?.OD,
              rcycreading: manualPrescription.CYL?.OD,
              raxisreading: manualPrescription.AX?.OD,
              radddetails: manualPrescription.ADD?.OD,
              pupdistance: pupillaryDistanceIsSingleValue ? manualPrescription.PD?.OD : undefined,
              rpupdistance: pupillaryDistanceIsSingleValue ? undefined : manualPrescription.PD?.OD,
              lpupdistance: pupillaryDistanceIsSingleValue ? undefined : manualPrescription.PD?.OS,
              rhprysm: manualPrescription.HPRISM?.OD,
              rhprysmbase: manualPrescription.HBASEDIR?.OD,
              rvprysm: manualPrescription.VPRISM?.OD,
              rvprysmbase: manualPrescription.VBASEDIR?.OD,
              lhprysm: manualPrescription.HPRISM?.OS,
              lhprysmbase: manualPrescription.HBASEDIR?.OS,
              lvprysm: manualPrescription.VPRISM?.OS,
              lvprysmbase: manualPrescription.VBASEDIR?.OS,
              COMMENT: manualPrescription.COMMENT ?? '',
              issueDate: manualPrescription.issueDate ?? '',
              doctorName: manualPrescription.doctorName ?? '',
            }

            $.ajax({
              url: window.wcs_endpoints['roxManualPrescription'],
              data: JSON.stringify(normalizedObject),
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json'
            })
          }
          localStorage.setItem('previousRemoved', '');
          const updateCart = new CustomEvent('addToBag', { detail: { withRedirectToCart: true } });
          const zipCodeNum = $('#zipcode').val();
          const orderIdNum = $('#orderId').val();
          //condition for BR store
          if ($("#countryCode").val() === 'BR' && zipCodeNum) {
            $.ajax({
              url: '/webapp/wcs/stores/servlet/RaybanCallICFreightAPIServiceCmd',
              data: {
                'orderId': orderIdNum,
                'postalCode': zipCodeNum.replace(/-/g, ''),
                'storeId': $('#storeId').val()
              },
              type: 'GET',
              dataType: 'json',
            }).done(function() {
              const params = {};
              params.orderId = orderIdNum;
              params.shipModeId = $('.wcs-shipping-mode-br input:checked').val();
              params.brazilShippingDays = $('#wcs-shipping-selector-NOR + .wcs-shipping-mode-title span').html().trim().split(" ")[0];

              const zipCodeNum = $('#zipcode').val();
              if ($("#countryCode").val() === 'BR' && zipCodeNum) {
                params.brazilZipCode = zipCodeNum.replace(/-/g, '');
              }

              $.ajax({
                type: 'POST',
                url: 'AjaxShipChargeUpdate',
                data: params,
                async: false,
                success: function(data) {
                  document.dispatchEvent(updateCart);
                }
              });
            });
          } else {
            document.dispatchEvent(updateCart);
          }
        },
        error: function(xhr, status, error) {
          console.log(error, 'add saved item to cart error');
        }
      });
    });
  }

  function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
  }

  function saveForLater(textForMessage, lastAddeCatentry, forceReload) {
    deleteCookie('miniWhislistSaved');
    console.log('save for later !!!');
    let params = {},
      urlStr = window.wcs_endpoints['miniWishlist'],
      messageItem = $('.saved-for-later-message'),
      titleBox = messageItem.find('.saved-item-name'),
      revertLink = messageItem.find('.revert-link'),
      savedItemNum = $('.saved-for-later-section .num-box'),
      allSavedItems = $('.saved-for-later-section .wcs-shopping-item-content');

    params.storeId = $('#storeId').val();
    params.catalogId = $('#catalogId').val();
    params.langId = $('#langId').val();

    $.ajax({
      url: urlStr,
      type: "POST",
      data: params,
      dataType: "json",
      success: function(data) {
        var wishListItemsArray = data.wishLists[0].items;
        if (wishListItemsArray.length) {
          savedItemNum.text(wishListItemsArray.length);
          localStorage.setItem('previousRemoved', '');
          if (textForMessage) {
            titleBox.text(textForMessage);
            revertLink.attr('data-last-added', lastAddeCatentry);
            $('.removed-item-message').hide();
            messageItem.show();
          }
          allSavedItems.remove();
          $.each(wishListItemsArray, function(index, arrayItem) {
            const replacedImageUrl = arrayItem.image.replace(/&amp;/g, '&');
            const replacedPdpUrl = arrayItem.pdpURL && arrayItem.pdpURL.replace(/&amp;/g, '&');
            arrayItem.image = replacedImageUrl;
            arrayItem.pdpURL = replacedPdpUrl;
            setValuesToSavedForLaterItem(arrayItem, data.wishLists[0].wishListId);
          });
        }
        if (forceReload) {
          window.location.reload()
        }
      },
      error: function(error) {
        console.log(error);
      }
    });
  }

  if (document.readyState === 'complete') {
    loadRemovedItems();
  } else {
    window.addEventListener('load', loadRemovedItems);
  }

  function loadRemovedItems() {
    let previousRemovedItem = localStorage.getItem('previousRemoved');
    if (document.cookie.indexOf('savedForLater') !== -1) {
      saveForLater();
    }

    if (previousRemovedItem) {
      showPreviousStepMesaage(JSON.parse(previousRemovedItem));
    }

    $('body').on('click', '.revert-link', function() {
      const thisDataId = $(this).attr('data-element-id');
      tealium_data2track.push({
        id: 'Click',
        Tracking_Type: 'hiddenaction',
        Click_FocusElement: this,
        data_element_id: thisDataId,
      });
      let catentryVal = $(this).attr('data-last-added');
      $('[data-catentryId="' + catentryVal + '"]').find('.add-item-to-cart').trigger('click');

    });
  }

  window.add_product_tostar_remove_from_basket = function(
    catEntryId,
    configurationId,
    roxSet,
    textForMessage,
    notForWishList,
    addToWishlistButton,
    orderItemId,
    hasPrescription,
    eppCatEntryId,
    eppSet
  ) {
    var eyeProtectionCheckbox = addToWishlistButton.closest('.cart-item-container').find('#eyewearProtectionCheckbox')
    var isEyeProtectionSelected = eyeProtectionCheckbox.is(":checked");
    if (notForWishList) {
      let removedItemParams = {
        catEntryId,
        configurationId,
        roxSet,
        textForMessage,
        orderItemId,
        hasPrescription,
        isEyeProtectionSelected,
        eppCatEntryId,
        eppSet,
        isGWP: addToWishlistButton.hasClass('wcs-gwp-remove-link'),
        orderId: addToWishlistButton.attr('rel-order')
      };
      localStorage.setItem('previousRemoved', JSON.stringify(removedItemParams));
      return Promise.resolve(true);
    }
    var wishListCnt = $('#wcs-viewlistcount').val();
    var params = {};
    params.catEntryId = catEntryId;
    params.configurationId = configurationId;
    params.langId = $('#langId').val();
    params.storeId = $('#storeId').val();
    params.eppSelected = isEyeProtectionSelected;
    params.catalogId = $('#catalogId').val();
    params.orderItemId = orderItemId;
    if (roxSet !== "" && roxSet !== undefined) {
      params.roxSet = roxSet;
      params.configurationId = roxSet;
    }

    return $.ajax({
      type: "POST",
      dataType: "json",
      url: "WishListAddCmd",
      timeout: 3000,
      data: params,
      complete: function() {
        saveForLater(textForMessage, catEntryId, true);
      }
    })
      .done(function() {
        var page = $('#pName').val();
        var viewname = "WishListView";
        if (undefined !== page && page == 'remixconfigurator') {
          viewname = "MiniListView";
        }
        $("#wcs-star-container").children().remove();
        $("#wcs-star-container").load(viewname + "?storeId=" + $("#storeId").val() + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function() {
          sidebarHideFavEmptyDiv();
          window.add_product_notification(star);
          //commented the below line to fix the bug RB-3666
          //window.shortlist_tray_length();
          // hide_deposit_container();
          custom_scrollable_hover();
          scroller();
          resize_panel_header_footer();
          sharePlus_emailToFriend_bind();
          openLinksInNewTab();
        });
        if ($(".wcs-mySelections-hidden").val() == "My Selections") {
          refresh_my_favorites_section();
        }
      })
      .fail(function() {
        return false;
      });
  };

  window.add_product_to_hometry = function() {
    $(tryathome).removeClass('wcs-hide');
    $.get("include/minibasket/hometry.php", function(data) {
      $(tryathome).append(data);
      home_try_length();
      shoping_cart_length();
      show_empty_container();
    });
  };

  var display_sidebar = $("#wcs-display-sidebar");


  /**
   * show_header_search
   * show/hide Advanced Search
   * if in a search result page, populate search input with current value
   */
  window.show_header_search = function() {

    var searchIsActive = $('.wcs-hd-menu-search').hasClass('active'),
      currSearchTerm = Rayban.utilities.getUrlParameter('searchTerm') || '';

    if (searchIsActive) {
      $('.wcs-content-glass').hide();
      hide_content_glass();
    } else if (currSearchTerm && $('#searchTypePage').val() !== 'NoResultsPage') {
      // user is in the result page:
      // prevent the opening of the main panel and show the suggestions
      $('.wcs-content-glass').show();
      show_content_glass('input-only', function() {
        // reset value & set focus on search input
        $('#search-text-box').val(currSearchTerm).focus();
        $('#search-text-box').keyup();
      });

    } else if (currSearchTerm && $('#searchTypePage').val() === 'NoResultsPage') {
      // show the main advanced search panel
      $('.wcs-content-glass').show();
      show_content_glass();
      // reset value & set focus on search input
      $('#search-text-box').val(currSearchTerm).focus();

    } else {
      // show the main advanced search panel
      $('.wcs-content-glass').show();
      show_content_glass();
      // reset value & set focus on search input
      $('#search-text-box').val(currSearchTerm).focus();
    }
  }

  window.right_slider_open_close = function(type, thisbutton) {
    var datatype = type;
    if ($('.wcs-right-panel > div, .wcs-right-panel').is(':animated')) {
      return false;
    } else {
      switch (datatype) {
        case "glass":
          show_header_search();
          break;
        case "bag":
          //Analytics Start
          var cartProdList = $('#formattedProd').val();
          var onlyCounty = $("#onlyCounty").val();
          var currency = $("#currency").val();
          var country = $("#county").val();
          var userType = $("#userType").val();
          var cartId = $("#orderId").val();
          if (cartId === '') {
            cartId = $("#aorderId").val(); //taking from MiniWishListAddToBag.jsp
          }

          //Analytics End

          display_content(bag, 36, 5, -185, datatype);
          $(thisbutton).siblings('.wcs-rightNav-feedback').animate({
            'opacity': '0',
            'right': '75px'
          }).hide();
          break;
        case "star":
          display_content(star, 60, 5, -240, datatype);
          $(thisbutton).siblings('.wcs-rightNav-feedback').animate({
            'opacity': '0',
            'right': '75px'
          }).hide();
          break;
        case "support":

          display_content(support, 85, 5, -300, datatype);
          $(thisbutton).siblings('.wcs-rightNav-feedback').animate({
            'opacity': '0',
            'right': '75px'
          }).hide();
          break;
      }
    }
  };

  /**
   * sticky_header_search
   * @param {Boolean}
   * add/remove sticky class
   */
  window.sticky_header_search = function(cmd) {
    var doSticky = (cmd === false) ? false : true;

    search_box_result.toggleClass('sticky', doSticky);
  };

  $(buttons).off("click.wcs").on("click.wcs", function(e) {
    var type = $(this).data("type");
    var thisbutton = $(this);
    if ((('selenium-bag' === this.id) && $("#selenium-bag").hasClass('avoidMiniCart')) || (('bag' === this.id) && $("#bag").hasClass('avoidMiniCart'))) {
      window.location.href = $('#shopBagURL').val();
      return false;
    }
    if ($('.wcs-drop_panel').is(':visible')) {
      $(".wcs-drop_panel").animate({
        'top': '100px'
      }, 500);
      $(".wcs-drop_panel").fadeOut();
      $(".wcs-header .wcs-down_arrow").hide().css('top', '-8px');
      setTimeout(function() {
        $(".wcs-fadeout").css('height', '').addClass('wcs-hide');
      }, 150);
      right_slider_open_close(type, thisbutton);

      $(".wcs-hd-menu .wcs-primary > a").removeClass('wcs-active');

    } else {
      right_slider_open_close(type, thisbutton);
    }

    e.preventDefault();
    e.stopPropagation();
  });

  var initialise_scroll_events = function() {

    $(window).scroll(function(e) {

      var doSticky = header.hasClass('sticky'),
        isHeaderSearchActive = header_search.hasClass('active');

      resize_panel_header_footer();

      if (!$('.wcs-right-panel > div').is(':visible') && !$('.wcs-quick-buy-lightbox').is(':visible') && !$('.wcs-drop_panel').is(':visible') && !$('#wcs_footer .wcs-ft-container ').children('div').is(':visible')) {
        //lazy_load();
      }
      if ($('.wcs-right-panel > div').is(':visible')) {
        scroller();
      }

      // hide advanced search on scroll
      if ($(window).scrollTop() > 200 && isHeaderSearchActive) {
        hide_content_glass();
      }

      // if header is sticky, make advanced search results panel sticky
      sticky_header_search(doSticky);

    });
  };

  initialise_scroll_events();

  $(window).off("resize.wcs").on("resize.wcs", function(e) {
    resize_panel();
    resize_panel_header_footer();
    scroller();
    initNavigation();
  });

  $(document).off("resize.wcs").on("resize.wcs", function(e) {
    resize_panel();
    resize_panel_header_footer();
    scroller();
  });

  window.enableBodyScroll = function() {
    $(document).unbind('touchmove.scroll');
  };
  window.disableBodyScroll = function(e) {
    enableBodyScroll();
    $(document).bind('touchmove.scroll', function(e) {
      e.preventDefault();
    });
  };

  window.handleAndroidScroll = function() {
    if (WcsBrowser.isAndroid) {
      $('.scroller, .wcs-hscroller').unbind('touchstart.scroll').bind('touchstart.scoll', function(e) {
        disableBodyScroll();
      }).bind('touchend', function() {
        enableBodyScroll();
      });
    }
  };

  window.add_to_bag_onload = function() {
    var total_count = $('#tcount').val();

    if (total_count === "" || total_count === "0" || total_count === undefined) {
      $(total_bag_circle).addClass('wcs-hide');
      $(total_bag_circle).addClass('wcs-hide').css('padding-top', '3px').html(total_count);
    } else {
      if (total_count > 9) {
        $(total_bag_circle).removeClass('wcs-hide').css('padding-top', '2px').html('+');
      } else {
        $(total_bag_circle).removeClass('wcs-hide').css('padding-top', '3px').html(total_count);
      }
      $('button[data-type="bag"]').addClass('wcs-added');
    }

    scroller();
    handleAndroidScroll();
  };
  window.add_to_star_onload = function() {
    var total_star_count = $('#wcs-viewlistcount').val();

    if (total_star_count === "" || total_star_count === "0" || total_star_count === undefined) {
      $(total_star_circle).addClass('wcs-hide');
      $('button[data-type="star"] .wcs-product-count-circle').addClass('wcs-hide').css('padding-top', '3px').html(total_star_count);
    } else {
      if (total_star_count > 9) {
        $('button[data-type="star"] .wcs-product-count-circle').removeClass('wcs-hide').css('padding', '1px 0px').html('+');
      } else {
        $('button[data-type="star"] .wcs-product-count-circle').removeClass('wcs-hide').css('padding-top', '3px').html(total_star_count);
      }
      $('button[data-type="star"]').addClass('wcs-added');
    }

    scroller();
  };
  add_to_bag_onload();
  add_to_star_onload();
  resize_panel();
  resize_panel_header_footer();

  /* iPad fixes */
  if ($('html').hasClass('touch')) {
    /* for right nav to close on click of body, if right nav is open */
    document.addEventListener('touchmove', function(e) {
      if ($('.wcs-right-panel').width() > 0) {
        e.preventDefault();
        $('.wcs-fadeout-right-nav').on('touchstart', function() {
          slide_back_right_panel();
        });
      }
    }, true);
    /* for compare select check box */
    $('.wcs-compare-cbox').off('touchstart.wcs').on({
      'touchstart.wcs': function() {
        if ($('.wcs-product-compare').length > 0) {
          addid($(this));
        }
      }
    });
    /* for compare ADD TO BAG && ORDER AGAIN */
    $('.wcs-addtobag').off('touchstart.wcs').on({
      'touchstart.wcs': function(e) {
        var productID = $(this).data("product_id");
        if (productID) {
          product_ID_fn(e);
        }
      }
    });
    /* for closing tax calculate overlay */
    $('.wcs-container').off('touchstart.wcs').on({
      'touchstart.wcs': function(e) {
        if (!$(e.target).is('select#state') && !($(e.target).is('#wcs-calculate-tax') || $(e.target).is('#wcs-recalculate-tax')) || !$(e.target).find('> a#wcs-calculate-tax')) {
          $('#wcs_calTax_notification:visible').hide();
        }
        if ($(e.target).is('form#wcs-taxCal-form div') || $(e.target).is('#wcs_calTax_notification span') || $(e.target).is('form#wcs-taxCal-form ul li') || $(e.target).is('form#wcs-taxCal-form input') || $(e.target).is('#wcs_calTax_notification')) {
          $('#wcs_calTax_notification').show();
        }
        /*for closing the tooltip in myorders page */
        $('.wcs-notification-box').addClass('wcs-hidden');
        /**Avoid condition for amex card icon onhover on payment page**/
        if ($(e.target).is('.wcs-icon')) {
          var nbox = $(e.target).find('.wcs-notification-box');
          var middle_height = nbox.height() / 2;
          var notification_box_top = -middle_height + 12;
          nbox.css('top', notification_box_top);
          if (!($(e.target).find("p").hasClass("amex-info") || $(e.target).find("p").hasClass("not-amex-info"))) nbox.children('span.wcs-notification-arrow').css('top', middle_height - 10);
          nbox.removeClass('wcs-hidden');
        }
      }
    });
    $('.wcs-quick-buy-lightbox').off('touchstart.wcs').on({
      'touchstart.wcs': function(e) {
        if ($(e.target).data('save_id')) {
          if (!$($(e.target).siblings()[0]).hasClass('wcs-saved')) {
            window.product_opration("save_product", "");
            $($(e.target).siblings()[0]).toggleClass('wcs-saved').toggleClass('wcs-quickbuy-star');
          }
          e.preventDefault();
        }
        if ($(e.target).data("product_id")) {
          product_ID_fn(e);
        } else if ($(e.target).data("product_mini_id")) {
          product_miniID_fn(e);
        }

        var getCloseBtn = $(e.target).attr('class');
        if (getCloseBtn == "wcs-close-btn") {
          $('.wcs-quick-buy-lightbox .wcs-close-btn').trigger('click');
          $('.wcs-product').mouseout();
          e.preventDefault();
          e.stopPropagation();
        }
        if ($(e.target).is('#wcs-quick-view-details')) {
          var country = $("#county").val();
          var userType = $("#userType").val();

          window.location = $(e.target).attr('href');
        }

      }
    });
  }



  /*----------------------------------------------
        CODE FOR PRODUCT QUICK BUY
        ----------------------------------------------*/
  var arrow_left;
  var slider_li_next_count = 0;
  var scroll_li_position_diff;
  var slider_li;
  var slide_count = 0;

  var reset_rightslider_quickbuy = function() {
    hide_fadeout();
    hide_full_fadeout(qvId);
    fadeout_panel.removeAttr('style');
    hide_D_QuickView(qvId);
  };
  window.hide_D_QuickView = function(qvId) {
    if (qvId !== "D_QuickView" && qvId !== "D_QuickView_Prod") {
      $('#' + qvId).hide();
    } else if (window.isROX === true) {
      $('#D_QuickView_Prod').hide().children().remove();
    } else {
      $('#D_QuickView').hide().children().remove();
    }
  };
  var display_center = function(divObject, skipDelay) {
    var scrollTop = $(document).scrollTop();
    var left = ($(window).width() - divObject.width()) / 2;
    var bodyHeight = $('body').height() + 90;
    var divHeight = divObject.height();

    /* fix for calculate heigth after bxslider loaded */
    if ((divObject.attr('id') == 'D_QuickView' || divObject.attr('id') == 'D_QuickView_Prod') && divObject.find('#quick-buy-carousel-div li').length > 4 && !skipDelay) {
      var thisDivObject = divObject;
      window.setTimeout(function() {
        display_center(thisDivObject, true);
      }, 10);
    }

    var top = ($(window).height() - divHeight) / 2 + scrollTop;

    if ($('body').hasClass('android') && top + divHeight > bodyHeight) {
      top = top - (top + divHeight - bodyHeight);
      scrollTop = top - 40;
      if (scrollTop < 0) scrollTop = 0;
      if (top < 0) top = 0;
      $(document).scrollTop(scrollTop);
    }

    divObject.css({
      'left': left,
      'top': top
    });
  };

  $('body').on('click', '#wcs-tc-close', function() {
    $('#wcs-terms-and-condition .wcs-close-btn').trigger('click');
  });
  /* Terms and Condition LightBox Logic- Submitting Logon Form*/
  $('#terms_and_conditions_submit').off("click").on("click", function(ev) {
    if ($('#pgName').val() == 'ChangePassword') {
      ev.preventDefault();
      $('#form_password_reset').find('input:submit').trigger('click');
    } else {
      $('#user_login_form').find('input:submit').trigger('click');
    }

  });

  window.show_quick_buy = function(data) {
    var quickBuyID = $(data).data("quick_buy_id"),
      parentId = $(data).data("parent_id"),
      styles = $(data).data("styles"),
      price = $(data).data("price"),
      clearance = $(data).data("clearance"),
      pageType = $("#pageTemplate").val(),
      producttype = $("#producttype").val(),
      orderId = $("#orderId").val();
    if (clearance === undefined) {
      clearnace = "";
    }
    var recommended = $("#recommended").val();
    if (recommended === undefined) {
      recommended = "no";
    }
    if (producttype === undefined && pageType === undefined) {
      producttype = "Search";
      pageType = "InternalSearchResults";
    }
    var prodList = $(data).parents('.wcs-product-group').next('input#sku').val();
    var prodCategory = prodList.split(';');
    var ajaxURL = '/webapp/wcs/stores/servlet/QuickInfoDetailsView?catentryId=' + quickBuyID + '&parentId=' +
      parentId + '&styles=' + styles + '&price=' + price + '&pageType=' + pageType + '&prodCategory=' + prodCategory[0] + '&producttype=' + producttype + '&recommendedFlag=' + recommended + '&orderId=' + orderId;

    /*  Add additional store parameters this is needed for caching */
    var storeId = $('#storeId').val();
    var catalogId = $('#catalogId').val();
    var langId = $('#langId').val();
    var TopCategoriesDisplayURL = $('#TopCategoriesDisplayURL').val();
    if (storeId !== undefined) {
      ajaxURL = ajaxURL + "&storeId=" + storeId;
    }
    if (catalogId !== undefined) {
      ajaxURL = ajaxURL + "&catalogId=" + catalogId;
    }
    if (langId !== undefined) {
      ajaxURL = ajaxURL + "&langId=" + langId;
    }
    if (TopCategoriesDisplayURL !== undefined) {
      ajaxURL = ajaxURL + "&TopCategoriesDisplayURL=" + TopCategoriesDisplayURL;
    }
    if ($('#page') !== undefined && $('#page').val().indexOf('clearance') != -1) {
      ajaxURL = ajaxURL + "&clearance=true";
    }

    $.ajax({
      type: "POST",
      dataType: "text",
      url: ajaxURL,
      async: false,
      success: function(data) {
        var quickBuyDiv = "";
        if (window.isROX === "true") quickBuyDiv = $('#D_QuickView_Prod');
        else quickBuyDiv = $('#D_QuickView');
        quickBuyDiv.html(data);
        if (quickBuyDiv.find('p.wcs-preorder-label').length > 0) {
          quickBuyDiv.find('.wcs-border-d1d1d1').addClass('wcs-preorder_div');
        }
        show_full_fadeout();
        quickBuyDiv.show();
        display_center(quickBuyDiv);
        slider_li = $('#quick-buy-carousel-div').find('div.slider li');
        expand_dropbox();
        collapse_dropbox();
        dropscrollerFn();
        select_dropbox_value();
        key_nav_dropdown();
        /* Remove the hurry up section if the result is empty to avoid extra spaces */
        if (!$.trim($('#wcs-hurryUp').html()).length) {
          $('#wcs-hurryUp').hide();
        } else {
          $('#wcs-hurryUp').show();
        }
        var quickViewContainer = "";
        if (window.isROX === "true") quickViewContainer = $("#D_QuickView_Prod");
        else quickViewContainer = $("#D_QuickView");
        quickViewContainer.find(".wcs-quickView-product-list").off('click').on('click', function(e) {
          e.preventDefault();
          getDataAttrId = $(this).attr('style_sku');
          $(".wcs-quickView-product-list").removeClass('wcs-activate-icon');
          $(this).addClass('wcs-activate-icon');
          var targetSKU = $(this).attr('data-product_sku');
          var changeSize = 'TRUE';
          change_product_properties(targetSKU, changeSize);
          if (!$("#wcs-size-wrapper1").hasClass("dropscroller")) {
            $("#wcs-size-wrapper1").addClass("wcs-hide");
          }
        });
        var defaultSkuValue = quickBuyDiv.find('input#firstSkuValue').val();
        var sliderlist = $('#quick-buy-carousel-div').find('li');
        $.each(sliderlist, function(k, v) {
          $(this).removeClass('wcs-activate-icon');
          if ($(this).attr('data-product_sku') == defaultSkuValue) {
            $(this).addClass('wcs-activate-icon');
            startwith = $(this).index();
          }
        });
        close_lightbox();
        load_scroller();
        openLinksInNewTab();
        if (window.initNotification) initNotification();
        initQuickviewOffersTooltip();

        $(".add-bag-bg").on("click", function() {
          sessionStorage.removeItem("rayban." + $("#storeId").val() + "." + $("#langId").val() + ".sidebar_refreshLS");
          sessionStorage.removeItem("rayban." + $("#storeId").val() + "." + $("#langId").val() + ".headerprofile_refreshLS");
        });

        $(".wcs-fav-container .wcs-save").on("click", function() {
          sessionStorage.removeItem("rayban." + $("#storeId").val() + "." + $("#langId").val() + ".sidebar_refreshLS");
          sessionStorage.removeItem("rayban." + $("#storeId").val() + "." + $("#langId").val() + ".headerprofile_refreshLS");
        });
      }
    });
  };

  var close_header_drop_panel_fn = function() {
    $(".wcs-drop_panel").fadeOut('fast');
    $(".wcs-drop_panel").slideUp('fast');
    $(".wcs-hd-menu .wcs-primary > a").removeClass('wcs-active');
    $(".wcs-header .wcs-down_arrow").animate({
      top: -8
    }, 400);
    $(".wcs-fadeout").css('height', '').addClass('wcs-hide');
  };


  var reloadDOM = function() {
    document.location.reload(false);
  };

  /* Terms and Condition LightBox Logic*/
  window.close_lightbox = function() {

    //RB:8167
    $('.wcs-fadeout-full, .wcs-fadeout, .wcs-quick-buy-lightbox .wcs-close-btn, .wcs-quick-buy-lightbox .wcs-close-btn-2').not(".wcs-fadeout-full-overlay").off('click').on('click', function() {
      document.documentElement.style.removeProperty("overflow-y");
      if ($(this).hasClass("wcs-fadeout-full") && ($(".wcs-quick-buy-lightbox:visible").attr("id") == "wcs-support-chat-popup" || $(".wcs-quick-buy-lightbox:visible").attr("id") == "wcs-support-chat-direct-popup")) {
        return false;
      }

      const triggerSource = $(this).data('triggerSource')
      if(triggerSource){
        triggerSource.focus()
      }

      $(this).parent().removeClass("wcs-remixed-compare-view");


      /* Disabling print.css */
      if ($('#wcs_print_order_css').length) {
        cssPrint = $('link[rel=stylesheet][title=print]');
        if (cssPrint.attr('disabled')) {
          cssPrint.removeAttr('disabled');
        } else {
          cssPrint.attr('disabled', 'true');
        }
      }

      qvId = $(".wcs-quick-buy-lightbox:visible").not(".wcs-draggable-lenses-full-view-hide").attr("id");
      var lightBoxModalId = $(this).closest(".wcs-quick-buy-lightbox:visible").not(".wcs-draggable-lenses-full-view-hide").attr("id");

      if (!(($(this).hasClass('wcs-fadeout-full')) && ($('#wcs-terms-and-condition:visible').length > 0))) {
        const $formWrapper = $(this).closest('#add-address-modal');
        const $jpPhoneField = $formWrapper ? $formWrapper.find('.jp-phone-container') : null;

        if ($jpPhoneField) {
          $jpPhoneField.removeClass('phone-invalid');
        }

        $("#privacyPolicyAttr").attr('name', 'privacyPolicyPref');
        $("#loginEmail").val('');
        $("#wcs_logon_password").val('');
        hide_full_fadeout(lightBoxModalId);
        hide_D_QuickView(lightBoxModalId);

        //RB:8167

        close_header_drop_panel_fn();
        var formObj = ($("#" + qvId).find('form'));
        if (formObj.length) {
          clear_form(formObj);
          $('.delivery-info-error').hide();
        }

        if (qvId == "size-guide-overlay") {
          hide_full_fadeout(qvId);
        }

      }


      /* Removing the compare while closing the compare lightbox.*/

      if ($(this).parents('div.wcs_compare_quickview')) {
        reset_compare();
      }

    });
    $('#wcs-tc-close-pp').click(function() {
      $(this).parents('.wcs-print-preview-wrapper').children('span.wcs-close-btn').trigger('click');
      $(this).closest('.wcs-quick-buy-lightbox').find('.wcs-close-btn').trigger('click');
    });
  };

  close_lightbox();

  window.load_scroller = function() {
    $(function() {
      var qSliderDiv = $("#quick-buy-carousel-div div.slider");
      var sliderln = qSliderDiv.find("li").length;
      if (startwith < 4) {
        startwith = 0;
      } else if (sliderln - startwith < 4) {
        startwith = sliderln - 4;
      }
      window.wcsQSlider = qSliderDiv.find('ul').bxSlider({
        infiniteLoop: false,
        hideControlOnEnd: true,
        slideWidth: 148,
        startSlide: startwith,
        slideMargin: 12,
        pager: false,
        minSlides: 1,
        maxSlides: 4,
        moveSlides: 4,
        preloadImages: 'all',
        onSliderLoad: function() {
          if (sliderln < 5) {
            qSliderDiv.find('div.bx-wrapper').css('margin', '0');
            qSliderDiv.find('div.bx-wrapper').css('margin-left', '-28px');
          }
        }
      });
      if (sliderln < 5) {
        qSliderDiv.find('div.bx-controls').addClass('wcs-hide');
      }
    });
  };

  var position_slider_arrow = function(arrow_left) {
    $('#quick-buy-carousel-div').find('.wcs-down-arrow').animate({
      left: arrow_left
    }, 200);
  };

  window.bind_slider_product_click = function(productClickedObj) {
    _self = productClickedObj;
    arrow_left = _self.position().left + 50;

    if (slider_li_next_count) {
      arrow_left = arrow_left - scroll_li_position_diff * slider_li_next_count;
    }
    position_slider_arrow(arrow_left);
  };

  window.bind_slider_functionality = function() {
    $('#quick-buy-carousel-div').find('.wcs-slider-next').off('click').on('click', function() {
      if ($(this).hasClass('wcs-slider-next-enabled')) {
        slider_li_next_count++;
        slide_count++;
        manage_slider_navigation_arrow();
      }
    });

    $('#quick-buy-carousel-div').find('.wcs-slider-prev').off('click').on('click', function() {
      if ($(this).hasClass('wcs-slider-prev-enabled')) {
        slider_li_next_count--;
        slide_count--;
        manage_slider_navigation_arrow();
      }
    });
  };

  var manage_slider_navigation_arrow = function() {
    if (slide_count) {
      enable_slider_prev_arrow();
    } else {
      disable_slider_prev_arrow();
    }
    if (slide_count >= slider_li.length - slider_visible_product) {
      disable_slider_next_arrow();
    } else {
      enable_slider_next_arrow();
    }
  };
  var enable_slider_prev_arrow = function() {
    $('#quick-buy-carousel-div').find('.wcs-slider-prev').addClass('wcs-slider-prev-enabled');
  };
  var enable_slider_next_arrow = function() {
    $('#quick-buy-carousel-div').find('.wcs-slider-next').addClass('wcs-slider-next-enabled');
  };
  var disable_slider_prev_arrow = function() {
    $('#quick-buy-carousel-div').find('.wcs-slider-prev').removeClass('wcs-slider-prev-enabled');
  };
  var disable_slider_next_arrow = function() {
    $('#quick-buy-carousel-div').find('.wcs-slider-next').removeClass('wcs-slider-next-enabled');
  };
  /*CR, more feedback for right nav add to bad, search and favourite*/
  if (!$('body').is('.ipad')) {
    $('.wcs-right-nav .wcs-button').hover(function() {
      if (!$('.wcs-right-panel > div').is(':visible')) {
        $(this).find('.wcs-rightNav-feedback').css({
          'display': 'block',
          'opacity': '0'
        }).animate({
          'opacity': '1',
          'right': '53px'
        }, 400);
      }
    }, function() {
      if (!$('.wcs-right-panel > div').is(':visible')) {
        $(this).find('.wcs-rightNav-feedback').animate({
          'opacity': '0',
          'right': '75px'
        }, 200, function() {
          $(this).hide();
        });
      }
    });
  }
  /* changes for search as you type starts */

  var autoSuggestTimer = -1;
  var autoSuggestKeystrokeDelay = 250;
  var autoSuggestThreshold = 2;
  var maxSrchTerms = 5;
  loadSrchKeywords();

  //on mouse hover on the typed word in the suggested sidebar, make a new search with that term
  var $suggestedSearchText = $('.suggested .search-bar-text');
  $suggestedSearchText.on("hover", function() {
    var $searchTextBox = $('#search-text-box');
    var srchTerm = $(this).attr("alt");
    var srchURL = $searchTextBox.attr('data-autosuggest-url');
    triggerAutoSuggest(srchTerm, srchURL, 'event', true);
  });

  window.triggerAutoSuggest = function(srchTerm, srchURL, event, updateProductListOnly) {
    setCookieAsianFitDefaultFilter();
    if ($.trim(srchTerm).length > autoSuggestThreshold) {
      doDynamicAutoSuggest(srchTerm, srchURL, true, updateProductListOnly);
    }

    // srchTerm is the text typed in search box
    if (event && event.type && (event.type === 'keyup')) {
      searchText.text(srchTerm);

      //update the link of the typed word printed at the beginning of .suggested sidebar
      var searchResultUrl = buildSearchPageUrl(srchTerm);
      if ($("[name=isAsianFitAvailable]").length != 0) {
        searchResultUrl += '&facet=' + Rayban.utilities.readCookie('AsianFitDefaultFilter');
      }
      $suggestedSearchText
        .attr('href', searchResultUrl)
        .attr('alt', srchTerm)
        .attr('aria-label', srchTerm);
    }

    if ($('.header-search-text-box').val().length == 0) {
      resetSearchBox();
    }

    if (srchTerm.length === "") {
      if (getCookie("RBSrchTerms") != null) {
        $("#slidePrevSearch").removeClass('wcs-hidden');
      }
      $("#slidePopSearch").removeClass('wcs-hidden');
      $(".usefull-links").removeClass('wcs-hidden');
      $(".suggested").addClass("wcs-hidden");
      $("#slideSearchAll, #slideSearchProduct").addClass('wcs-hidden');
      $(".wcs-slide-search-viewAll").addClass("wcs-hide");
      $('.dnkws-label').removeClass('wcs-hide');
      $('.si-label').removeClass('wcs-hide');
      $('#suggestSrchResults').empty();
      $('.live-campaign').removeClass("wcs-hidden");
    }
  };


  function doDynamicAutoSuggest(searchTerm, srchURL, showHeader, updateProductListOnly) {
    // Trim start/end whitespaces
    searchTerm = trimTerm(searchTerm);
    $('.title-left .search-bar-text').text(searchTerm);

    // if pending autosuggest triggered, cancel it.
    if (autoSuggestTimer != -1) {
      clearTimeout(autoSuggestTimer);
      autoSuggestTimer = -1;
    }
    // call the auto suggest
    autoSuggestTimer = setTimeout(function() {
      var params = {};
      var wordCount = countWords(searchTerm);
      params.term = escape(searchTerm);
      params.unescapedTerm = searchTerm;
      params.searchTerm = searchTerm;
      params.wordCount = wordCount;
      params.pageSize = 3;
      params.viewMode = 'Rayban';
      params.showHeader = true;
      params.catalogId = $("#WC_CachedHeaderDisplay_FormInput_catalogId_In_CatalogSearchForm_1").val();
      params.storeId = $("#WC_CachedHeaderDisplay_FormInput_storeId_In_CatalogSearchForm_1").val();
      params.langId = $("#WC_CachedHeaderDisplay_FormInput_langId_In_CatalogSearchForm_1").val();
      if ($("[name=isAsianFitAvailable]").length != 0) {
        params.facet = Rayban.utilities.readCookie('AsianFitDefaultFilter');
      }
      $.ajax({
        url: srchURL,
        data: params,
        dataType: 'json',
        type: 'get',
        success: function(data) {
          //what results do i have
          var hasSuggestedKeywords = false;
          var hasProductResults = false;
          if (data && data.products) {
            hasSuggestedKeywords = data.products.custom_suggest_keywords && data.products.custom_suggest_keywords.length > 0;
            hasProductResults = data.products.products && data.products.products.product && data.products.products.product.length > 0;
          }
          //show result dropdown
          if (hasProductResults) {
            $("#slidePopSearch, #slidePrevSearch, .usefull-links").addClass("wcs-hidden");
            $('.live-campaign').addClass("wcs-hidden");
            $('.feature-product').addClass("wcs-hide");
            $(".wcs-slide-search-viewAll").removeClass("wcs-hide");
            $('.dnkws-label').addClass('wcs-hide');
            $('.si-label').addClass('wcs-hide');

            //suggested keywords
            if (!updateProductListOnly) {
              if (hasSuggestedKeywords) {
                //var allResultDisplayURL = jsonresponse.AllResultDisplayURL.split('&amp;').join('&');
                var keywords = [];
                var searchKeyword = $.trim($('#search-text-box').val());
                var isSearchKeywordAmongSuggestions = false;
                for (var i = 0; i < data.products.custom_suggest_keywords.length; i++) {
                  var word = data.products.custom_suggest_keywords[i];
                  var searchResultUrl = buildSearchPageUrl(word);
                  keywords.push({
                    word: word,
                    wordMarkup: word,
                    searchResultUrl: searchResultUrl
                  });
                  if ($.trim(word).toLowerCase() === searchKeyword.toLowerCase()) {
                    isSearchKeywordAmongSuggestions = true;
                  }
                }

                $('.suggested .search-bar-text').toggleClass('wcs-hide', isSearchKeywordAmongSuggestions);

                var $suggestion = $('.wcs-new-search-box-result .suggestion');
                $suggestion.html(Rayban.templates['suggested_keywords_template'](keywords));

                //on mouse hover on a suggested word make a new search with that term
                $suggestion.find('a').on("hover", function() {
                  var $searchTextBox = $('#search-text-box');
                  var srchTerm = $(this).attr("alt");
                  var srchURL = $searchTextBox.attr('data-autosuggest-url');
                  triggerAutoSuggest(srchTerm, srchURL, 'event', true);
                });

                $suggestion.find('a').each(function(index, elem) {
                  $(elem).attr('aria-label', $(elem).attr('alt'));
                });

                $suggestion.find('a').wrapInTag({
                  tag: 'mask',
                  words: searchKeyword.split(" ")
                });

                $('.wcs-new-search-box-result').removeClass('suggested-keywords-empty');
                $(".suggested").removeClass("wcs-hidden");
              } else {
                $('.wcs-new-search-box-result').addClass('suggested-keywords-empty');
              }
            }

            //product results
            window.autoSuggestTiles = window.autoSuggestTiles || new TilesView('#suggestSrchResults');
            if (data.products === undefined && data.contentdata === undefined) {
              $(".wcs-slide-search-viewAll").addClass("wcs-hide");
              $('.dnkws-label').removeClass('wcs-hide');
              $('.si-label').removeClass('wcs-hide');
            }
            var productData = new Array(data.products);
            autoSuggestTiles.render(productData, false);

            // show results
            show_results_glass();

          } else {
            //no product result: hide result dropdown
            show_results_glass(false);
          }
        }
      });
      autoSuggestTimer = -1;
    }, autoSuggestKeystrokeDelay);
  }

  function countWords(str) {
    str = str.replace(/(^\s*)|(\s*$)/gi, "");
    str = str.replace(/[ ]{2,}/gi, " ");
    str = str.replace(/\n /, "\n");
    return str.split(' ').length;
  }

  function trimTerm(str) {
    return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
  }

  window.resetSearchBox = function() {
    $('.wcs-new-search-box-result').removeClass('suggested-keywords-empty');
    if (getCookie("RBSrchTerms") != null) {
      $("#slidePrevSearch").removeClass('wcs-hidden');
    }
    $("#slidePopSearch").removeClass('wcs-hidden');
    $(".usefull-links").removeClass('wcs-hidden');
    $(".suggested").addClass("wcs-hidden");
    $('#suggestSrchResults').empty();
    $('.live-campaign').removeClass("wcs-hidden");
    $('.feature-product').removeClass("wcs-hide");
    $('.wcs-slide-search-viewAll').addClass('wcs-hide');
    $('.dnkws-label').removeClass('wcs-hide');
    $('.si-label').removeClass('wcs-hide');
    // restore results panel (if hidden)
    show_results_glass();
  };

  window.persistSrchKeywords = function(srchTerm, submitSearchForm) {
    var rawcookie = getCookie("RBSrchTerms");
    var srchKeywords = srchTerm;
    if (rawcookie !== null) {
      var ckData = unescape(rawcookie);
      var ckVals = ckData.split(';');
      var ckLength = ckVals.length;
      var indexFound = $.inArray(srchTerm, ckVals);
      var ckValsNew = [];
      if (indexFound == -1) {
        if (ckLength < maxSrchTerms) {
          ckVals[ckLength] = srchTerm;
        } else {
          for (var index = 1; index < ckLength; index++) {
            ckValsNew[index - 1] = ckVals[index];
          }
          ckValsNew[ckLength - 1] = srchTerm;
          ckVals = ckValsNew;
        }
      } else {
        var j = 0;
        for (var i = 0; i < ckLength; i++) {
          if (i != indexFound) {
            ckValsNew[j] = ckVals[i];
            j++;
          }
        }
        ckValsNew[ckLength - 1] = srchTerm;
        ckVals = ckValsNew;
      }
      srchKeywords = ckVals.join(";");
    }
    if (rawcookie === null) {
      srchKeywords = srchKeywords;
    }
    SetCookie("RBSrchTerms", srchKeywords, 30);
    srchTerm = $.trim(srchTerm);
    if (srchTerm === "") {
      return false;
    } else if (submitSearchForm) {
      var analyticsSrchTermCookie = getCookie('analytics_srch_term');
      if (analyticsSrchTermCookie !== null) {
        SetCookie("analytics_srch_term", "", -1);
      }

      srchTerm = srchTerm;
      $("#search-text").val(srchTerm);
      document.forms.CatalogSearchForm.action = document.forms.CatalogSearchForm.action + '&searchTerm=' + srchTerm;
      document.forms.CatalogSearchForm.submit();
    }
  };

  window.buildSearchPageUrl = function(word) {
    return (location.hostname.indexOf('localhost') >= 0 ? '/webapp/wcs/stores/servlet' : '') + '/SearchDisplay?' +
      'catalogId=' + $('#catalogId').val() + '&langId=' + $('#langId').val() + '&storeId=' + $('#storeId').val() + '&' +
      'pageSize=9&clientSide=true&searchType=1000&resultCatEntryType=&viewMode=Rayban&showResultsPage=true&beginIndex=0&sType=SimpleSearch&newpage=true&' +
      'searchTerm=' + word.replace(' ', '+');
  }

  window.viewAllResult = function() {
    persistSrchKeywords();
    var a = document.getElementById('viewAllResult');
    a.href = buildSearchPageUrl($("#utility-search-form #search-text-box").val());

    setCookieAsianFitDefaultFilter();

    if ($("[name=isAsianFitAvailable]").length != 0) {
      a.href += '&facet=' + Rayban.utilities.readCookie('AsianFitDefaultFilter');
    }
  };

  function setCookieAsianFitDefaultFilter() {
    if ($("[name=isAsianFitAvailable]").length != 0) {
      // check the cookie
      if (Rayban.utilities.readCookie('AsianFitDefaultFilter') === null) {
        // get default value and save cookie
        if ($('#asianFitDefaultDisplay').val() === 'ASIAN') {
          document.cookie = "AsianFitDefaultFilter=" + $('#AsianFitAsianFilter').val() + ";path=/;";
        } else {
          document.cookie = "AsianFitDefaultFilter=" + $('#AsianFitInternationalFilter').val() + ";path=/;";
        }
      } else if ($('#AsianFitSearchTerms').length != 0) {
        var asianFitTerms = $('#AsianFitSearchTerms').val().toLowerCase().split("|");
        var searchTextInput = $('#search-text-box').val().toLowerCase();
        for (var i = 0; i < asianFitTerms.length; i++) {
          if (searchTextInput.indexOf(asianFitTerms[i]) >= 0) {
            document.cookie = "AsianFitDefaultFilter=" + $('#AsianFitAsianFilter').val() + ";path=/;";
          }
        }
      }
    }
  }

  function loadSrchKeywords() {
    var rawcookie = getCookie("RBSrchTerms");
    var srchLink = "";
    var srchTerm = $("#utility-search-form #search-text-box").val();
    if (rawcookie !== null) {
      var ckData = unescape(rawcookie);
      var ckVals = ckData.split(';');
      var ckLength = ckVals.length;
      for (var index = ckLength - 1; index >= 0; index = index - 1) {
        var srchURL = $("#WC_CachedDisplay_searchURL").val();
        srchURL = srchURL + '&searchTerm=' + ckVals[index];
        var len = ckVals[index].length - 1;
        srchLink = srchLink + "<li><a href=\"" + srchURL + "\">" + ckVals[index] + "</a></li>";
        if (index == ckLength - 1) {
          $("#search-text-box").val(ckVals[index]);
        }
      }
      $("#srchKeywordsList").html(srchLink);
      $("#slidePrevSearch").removeClass("wcs-hidden");
    } else {
      $("#search-text-box").attr("placeholder", $("#search-text-box").data("placeholder"));
    }

  }

  /* changes for search as you type ends */
  sharePlus_emailToFriend_bind();
  if ($(".wcs-pdp-price-container .strikePreviewPriceInner").length == 1 && $(".wcs-pdp-price-container #wcs-productprice").length == 1) {
    if ($(".wcs-pdp-price-container #wcs-productprice").text().match(/\d+/g).map(Number).toString().replace(/,/g, "") != $(".wcs-pdp-price-container .strikePreviewPriceInner").text().match(/\d+/g).map(Number).toString().replace(/,/g, "")) {
      $(".wcs-pdp-price-container .strikePreviewPriceInner").css("display", "inline");
    }
  }
  /*Bind support contact events*/
  /* $('#teaser_contactus a.wcs-support-teaser-button').off('click.contact').on('click.contact',function(ev){
       ev.preventDefault();
       $('div.wcs-fadeout-right-nav').click();
       $(window).scrollTo('max', 500,{'axis':'y' ,onAfter:function() {
           $('#wcs_contact_us').trigger('click');
       }});
   });*/
};

/*
 * ------------------------------------------------------------------------
 * RIGHT MENU SLIDER FUNCTION ENDS
 * --------------------------------------------------------------------------
 */

/* Function to remove the item from shopping cart - Added by suguna */

function onRemoveSelection(topic, data) {
  /* Remove Item from cart based on remove button click */
  $('.wcs-modified-table .wcs-shopping-item-content').each(function() {
    var getAttr = $(this).attr('data-attr').indexOf(data.objectId);
    var pageName = $('#page').val();
    var pgName = $('#shopCartPage').val();
    if (getAttr > 0) {
      if (pageName == 'ShopCartDisplay' || pgName == 'ShopCart') {
        var parentBlock = $(this).parent();
        parentBlock.remove();
        remove_shipping_mode();
        // update the shop bag header line
        $("#subTotal").html($("#subTotalCalc").html());
        $("#itemTotal").html(getTotalItemCount());
        $('#wcs-bag-qty-text').html($('#qtyText').val());
        if ($('div.wcs-custom-bag').length > 0) {
          $('div.wcs-fadeout-right-nav').height($('body').height() - 10);
        }
        if (roxInsuranceOverlayObj.isRoxInsEnabled) {
          /**Check multple items in cart of its insurance enabled**/
          roxInsuranceOverlayObj.check4MultipleItemsInCart();
        } else {
          $('body').overlayout();
        }
        $.publish("afterRemoveShoppingCartItem");
      }
    }
  });

  /* Basket Page - Apply promo code, calculate tax */
  $(".wcs-apply-promo-code-txt").each(function() {
    getAttr = $(this).attr("data-attr");
    if (data.objectId == getAttr) {
      $(this).removeClass('wcs-shopping-hide');
    }
  });
}

function subscribeMessages() {

  $.subscribe("removeItemFromCart", onRemoveSelection);
  $.subscribe("promoCode", onRemoveSelection);
}


/*****RB 283 js code signup overlay******/

OverlayError = function() {
  var overlay_bottommargin = $(".wcs-overlay-privacytxt").height() + 10;
  var overlay_margin = overlay_bottommargin + "px 0 0 -128px";
  $(".wcs-privacy-error-message").css("margin", overlay_margin);
};


$(window).load(function() {
  $("#overlay-content-response").hide();

  if ($("#signupOverlayEnabled").val() == "TRUE") {
    var overlay_delay = $("#signupOverlayDelay").val();
    setTimeout(function() {
      if ($('.wcs-fadeout-full').height() === 0) {
        //$("#overlay-content").find("#newsletter-signup").removeAttr('disabled');
        if ($.cookie) {
          OverlayCookie();
        }
        //overAllFormValidation();
        OverlayError();
      }
    }, overlay_delay);
  }

  $('.wcs-right-slider-nav .wcs-glass-icon-search-form.close').on("click", function() {
    window.resetSearchBox();
  });

  $('.close-search-label').on("click", function() {
    hide_content_glass();
  });

  $('.wcs-fadeout-right-nav').on("click", function() {
    if ($('.slider.search-active').length > 0) {
      if (!$('.wcs-fadeout-right-nav').hasClass('wcs-hide')) {
        hide_content_glass();
      }
    }
  });
});

window.OverlayCookie = function() {

  var newsletterOverlayPopUp = $('#newsletterOverlayPopUp').val();
  var headerCountryCode = '';
  var newDate = new Date().toISOString().slice(0, 10)
  var currentdate = newDate;
  if (typeof geoIp !== "undefined" && geoIp && geoIp !== 'null') {
    headerCountryCode = geoIp.substring(geoIp.indexOf('country_code=') + 13, geoIp.indexOf(',', geoIp.indexOf('country_code')));
  }

  if (typeof newsletterOverlayPopUp === "undefined") {
    newsletterOverlayPopUp = "Y";
  }

  var countryCode = $('#country').val();

  if (newsletterOverlayPopUp === "Y") {

    if (!$.cookie("already_signed") && headerCountryCode === countryCode) {
      if ($.cookie("created_date") !== null && $.cookie("created_date") !== undefined) {
        $(".wcs-fadeout-full-overlay").css("display", "none");
        $(".wcs-full-overlay-content").css("display", "none");
      } else {
        //RB:8167
        var cookievalue = $.cookie("created_date", currentdate, {
          expires: 90,
          path: '/'
        });
        window.display_center_1($(".wcs-full-overlay-content"));
        $(".wcs-fadeout-full-overlay").css("display", "block");
        $(".wcs-full-overlay-content").css("display", "block");
        $(".wcs-fadeout-full-overlay").css("z-index", 101);
        $(".wcs-fadeout-full:first").css({
          "z-index": 102,
          "height": "100%"
        });

        tealium_data2track.push({
          'id': 'Impression',
          'Page_Section2': 'SignUp',
        });
      }
    }
  }
};
$("#SignUpOverlay").submit(function(e) {
  e.preventDefault();
  if ($('#Confirm').length > 0) {
    if (!$('#Confirm').is(':checked')) {
      $("#Confirm").closest(".wcs-signup-privacy").addClass("error").append('<span class="exclamatory">!</span>');
    }
  }
  newletterSignupSubmitHandler({
    is_valid: true
  });
});

$(".wcs-label-check").click(function() {
  /***If checkbox checked remove error***/
  if ($('#Confirm').length > 0) {
    if (!$(this).hasClass('wcs-c-on')) {
      $(".wcs-signup-privacy").removeClass("error").find(".exclamatory").remove();
    }
  }
});

$("#signUpEmail").focus(function() {
  if (!$(".welcome_promo_error").is(".permanently-hide")) {
    $('.welcome_promo_error').addClass('permanently-hide');
    $("#signUpEmail").removeClass('ui-state-error');
    $("#signUpEmail").addClass('ui-state-valid');
    $(".exclamatory").remove();
  }
});

window.newletterSignupSubmitHandler = function(data, elem) {
  if (data.is_valid) {
    if ($('#Confirm') && $('#Confirm').length > 0 && !$('#Confirm').is(':checked')) return true;

    var privacyConfirm;
    if ($("#storeIdentifier").val() == "USA" || $("#storeIdentifier").val() == "CA" || $('.wcs-signup-privacy .wcs-label-check').hasClass('no-checkbox')) {
      privacyConfirm = true;
      privacyConfirm = true;
    } else if ($('#Confirm').is(':checked')) {
      privacyConfirm = true;
    } else {
      privacyConfirm = false;
    }
    if ($("#signUpEmail").hasClass("ui-state-valid") && privacyConfirm) {

      var signUpEmail = $("#signUpEmail").val().trim();
      var campaignName = $("#campaignNameOverlay").val().trim();
      var storeId = $("#storeId").val().trim();
      var langId = $("#langId").val().trim();
      var Confirm = privacyConfirm;
      var pageIdentifier = $("#pageIdentifier").val().trim();
      $.ajax({
        type: "POST",
        url: "SignUpOverlayCmd",
        data: {
          signUpEmail: signUpEmail,
          campaignName: campaignName,
          storeId: storeId,
          langId: langId,
          Confirm: Confirm,
          pageIdentifier: pageIdentifier
        },
        success: function(result) {
          var isEmailExist = false;
          if (result != null && result.includes("isEmailExistForPromo")) {
            var obj = JSON.parse(result);
            isEmailExist = obj.isEmailExistForPromo;
          }
          if (isEmailExist) {
            $('.welcome_promo_error').removeClass('permanently-hide');
            $('.welcome_promo_error').addClass('wcs-inline-block');
            $("#signUpEmail").addClass('h5-active');
            $("#signUpEmail").addClass('ui-state-error');
            $("#signUpEmail").removeClass('ui-state-valid');
            $(".welcome_promo_error").closest(".wcs-row").append('<span class="exclamatory">!</span>');
          } else {
            //$("#overlay-signup-form").hide();
            $("#SignUpOverlay").hide();
            $("#overlay-content-response").addClass("wcs-show");
            //$("#overlay-content").css('top','170px');
            //$('.wcs-fadeout-full-overlay').css('display','none');
            //$("#overlay-content-response").show();
            var currentdate = $.datepicker.formatDate('yy/mm/dd', new Date());
            $.cookie("already_signed", currentdate, {
              expires: 90,
              path: '/'
            });

            tealium_data2track.push({
              'id': 'X-X-X-X-SignupForm'
            });
          }
        },
        failure: function(result) {
          console.log("Newsletter signup failed");
          tealium_data2track.push({
            id: 'Event',
            Events_Error: '1',
            Error_Source: 'Anomaly',
            Error_Message: 'Newsletter signup failed', //if available, otherwise you can use the classname
            Error_Code: $("#pageIdentifier").val() + ' - SignUpOverlay - invalid email'
          });
        }
      });
    }
  } else {
    $("#signUpEmail").addClass("ui-state-error");
    show_error($("#signUpEmail"));
    tealium_data2track.push({
      id: 'Event',
      Events_Error: '1',
      Error_Source: 'User',
      Error_Message: 'Invalid E-mail ID', //if available, otherwise you can use the classname
      Error_Code: $("#pageIdentifier").val() + ' - invalid email'
    });
  }
  return false;
};

/********END RB 283 js code signup overlay**********/

/*********RB-1068***********/
window.holidayOverlayCookie = function() {
  var holidayDisplayArr = ["overlay", "sunglasses", "sonnenbrillen", "occhiali-da-sole", "lunettes-de-soleil", "products", "gunesgozlukleri", "gafas-de-sol", "eyeglasses", "lunettes-de-vue", "graduados", "optics", "sehbrillen", "gafas-de-visión", "occhiali-da-vista", "MyDetailsView", "MyOrdersView", "MySelectionView", "LogonForm", "TrackOrdersView", "personnaliser", "personalizza", "personalisieren", "kişiselleştir", "personalizar", "customise", "customize", "SearchDisplay", "gift-cards", "giftcard-balance"];
  var location_str = decodeURI(window.location.pathname);
  var holidayDisplayArr_len = holidayDisplayArr.length;
  //var loc_cust_len=loc_cust.length;
  for (var i = 0; i < holidayDisplayArr_len; i++) {

    var n = location_str.indexOf(holidayDisplayArr[i]);


    if (n >= 0) {

      var srt_len = holidayDisplayArr[i].length;
      var new_str = location_str.substr(n, srt_len);
      if (new_str !== '') {
        if ($.cookie("holidayOverlay") !== null) {
          $(".wcs-fadeout-full-overlay").css("display", "none");
          $(".wcs-full-overlay-content").css("display", "none");
        } else {
          var cookievalue = $.cookie("holidayOverlay", "true", {
            path: '/'
          });
          holidayoverlay_center(holidayDivObject);
        }
      }
      break;
    }

  }
};

window.holidayoverlay_center = function(holidayDivObject) {
  $(".wcs-fadeout-full").css("display", "block");
  var Overlayleft = ($(window).width() - $(holidayDivObject).width()) / 2;

  $(holidayDivObject).css({
    'left': Overlayleft,
    'display': 'block'

  });
};


if ($("#holidayoverlaydisplay").val() == "true") {
  var holidayDivObject = "#holiday_overlay";
  holidayOverlayCookie();
}
/*********END RB-1068***********/
